import type { ModuleProps } from '~/types';
import { getPermalink } from '~/utils/permalinks';

export const languages = {
  pt: 'Português',
  es: 'Español',
};

export type Languages = keyof typeof languages;

export const defaultLang = 'pt';

export const showDefaultLang = false;

export const ui = {
  pt: {
    components: {
      widgets: {
        beneficts: {
          features2: {
            title: 'Transforme Sua Carreira Médica com Nossos Cursos',
            subtitle:
              'Maximize sua flexibilidade, acesse conteúdo atualizado e amplie seus horizontes profissionais, tudo ao seu ritmo.',
            highlight: 'Atenção',
            items: [
              {
                title: 'Aprenda no Seu Ritmo',
                description:
                  'Com nossos cursos online, você tem total liberdade para estudar quando e onde for conveniente. Adequado para a agenda agitada de um médico, nossos cursos permitem que você faça sua própria programação.',
                icon: 'flat-color-icons:clock',
              },
              {
                title: 'Acesso Global',
                description:
                  'Independentemente de onde você esteja no mundo, nossos cursos online estão ao seu alcance. Tudo que você precisa é de uma conexão com a internet.',
                icon: 'flat-color-icons:touchscreen-smartphone',
              },
              {
                title: 'Conteúdo Atualizado',
                description:
                  'Nossa plataforma se mantém atualizada com os avanços mais recentes no campo da nefrologia. Fique por dentro das descobertas e tratamentos mais recentes em medicina renal.',
                icon: 'flat-color-icons:news',
              },
              // {
              //   title: 'Engajamento Interativo',
              //   description:
              //     'Nossos cursos não apenas apresentam materiais de aprendizagem de alta qualidade, mas também oferece locais de tira dúvida para aumentar seu engajamento e compreensão.',
              //   icon: 'flat-color-icons:assistant',
              // },
              {
                title: 'Economia Garantida',
                description:
                  'Nossos cursos online são uma opção econômica. Economize com custos de deslocamento, hospedagem e alimentação e invista no que importa: seu crescimento profissional.',
                icon: 'flat-color-icons:currency-exchange',
              },
              {
                title: 'Aprendizado Personalizado',
                description:
                  'Revisite as aulas e materiais de estudo quantas vezes quiser e ao seu próprio ritmo. Nossos cursos oferecem uma estrutura de aprendizado centrada no aluno, ideal para tópicos complexos em nefrologia.',
                icon: 'flat-color-icons:approval',
              },
              // {
              //   title: 'Rica Biblioteca de Recursos',
              //   description:
              //     'Nós complementamos nossas aulas com uma variedade de recursos digitais, como vídeos, podcasts e apresentações para tornar seu processo de aprendizado ainda mais compreensível e interessante.',
              //   icon: 'flat-color-icons:library',
              // },
              // {
              //   title: 'Rede Global de Contatos',
              //   description:
              //     'Junte-se a uma comunidade de profissionais e estudantes de nefrologia de todo o mundo. Expanda seu networking e troque experiências valiosas com seus colegas.',
              //   icon: 'flat-color-icons:globe',
              // },
              {
                title: 'Certificado de Conclusão',
                description:
                  'Após concluir o curso, você receberá um certificado, demonstrando sua dedicação e conhecimento aprimorado em nefrologia, uma adição valiosa ao seu currículo e perfil profissional.',
                icon: 'flat-color-icons:document',
              },
            ],
          },
        }, 
        //Pegar a versão anterior desse course modules.
        courseModules: {
          title: 'Veja Quais São os Módulos do Curso',
          content: 'Todos os módulos contem questões para fixar o conteúdo',
          fragments: {
            hours: { pt1: 'São mais de', pt2: 'horas de conteúdo em vídeoaulas' },
          },
        },
        professor: {
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Quem será o seu mentor:</h3>
              Luís Sette é médico nefrologista formado pela USP há 14 anos, com mestrado e doutorado na área. Também é professor adjunto de Nefrologia na Universidade Federal de Pernambuco desde 2014, onde acumulou mais de uma década de experiência na enfermaria de nefrologia, coordenando o cuidado de pacientes internados com as mais diversas doenças glomerulares.
 

              <br /><br />
              Durante sua trajetória, buscou aprimoramento nos Estados Unidos, com foco específico em glomerulopatias, uma área que tem paixão em ensinar e atender. Atualmente, divide sua prática médica entre o consultório privado e o ensino na UFPE para graduandos, internos e residentes de clínica e nefrologia.
              <br> <br>
              Em 2020, lançou o projeto <span class="font-bold">NEFROATUAL</span>, visando democratizar o ensino de Nefrologia e alcançando mais de 1200 alunos até o momento.`,
            },
          },
        },
        courseFAQs: {
          title: 'Perguntas Frequentes',
          subtitle: 'Tudo o que Você Precisa Saber Sobre Nossos Cursos',
          highlight: 'Saiba mais',
          items: [
            [
              {
                question: 'Qual é a duração desse cursos?',
                answer:
                  'Todos os nossos cursos têm duração de 1 ano. Isso significa que, após a compra, você terá acesso ao material do curso e poderá estudar no seu próprio ritmo durante esse período.',
              },
              {
                question: 'Esse cursos têm garantia? Se eu não gostar?',
                answer:
                  'Sim, oferecemos uma garantia incondicional de 30 dias. Se por qualquer motivo você decidir que o curso não é adequado para você dentro desse prazo, você poderá solicitar um reembolso total.',
              },
              {
                question: 'Quem ministra esse curso?',
                answer:
                  'Todos os nossos cursos são ministrados pelo Dr. Luís Sette, especialista em nefrologia com vasta experiência clínica e acadêmica. O Dr. Luís Sette dedica-se a tornar o aprendizado da nefrologia acessível e compreensível para todos.',
              },
            ],
            [
              {
                question: 'Como posso comprar?',
                answer:
                  'A compra pode ser realizada diretamente em nossa plataforma, através da nossa parceria com a Hotmart. Depois de escolher o curso que melhor atende às suas necessidades, basta seguir as instruções na página do curso para finalizar sua compra.',
              },
              {
                question: 'E se eu tiver outras perguntas ou precisar de ajuda?',
                answer:
                  'Estamos aqui para ajudar! Se tiver mais perguntas ou precisar de assistência, não hesite em entrar em contato conosco pelo direct do instagram, plataforma do Hotmart ou também pelo nosso Whatsapp. Nosso objetivo é garantir que você tenha uma experiência de aprendizado suave e enriquecedora.',
              },
              {
                question: 'Esse cursos oferece algum tipo de certificação?',
                answer:
                  'Sim, após a conclusão do curso, você receberá um certificado de conclusão para reconhecer seu comprometimento e dedicação ao avanço do seu conhecimento em nefrologia. Este certificado pode ser útil para fins de desenvolvimento profissional contínuo.',
              },
            ],
          ],
        },
        garantia: {
          content: {
            items: [
              {
                title: 'Você tem 30 DIAS de garantia a partir do momento que você se inscrever. Isso significa que você se inscreve e não gostar, por qualquer motivo que seja, pode pedir o seu reembolso à nossa equipe, e ele será feito integralmente. Simples assim. Sem burocracias ou insistências.',
                description:
                  '',
              },
              
            ],
            image: {
              alt: 'Garantia',
            },
            fragments: {
              content: {
                html: `
                <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">
                  RISCO ZERO
                </h3>`,
              },
            },
          },
        },
        priceDescription: {
          callToAction: {
            text: 'FAZER MINHA INSCRIÇÃO',
          },
          title: 'Garantia de 30 dias ou o seu dinheiro de volta',
          subtitle: 'Compre de forma segura pelo hotmart',
          image: {
            alt: 'Formas de Pagamento',
          },
        },
        reviews: {
          title: 'O que os nossos alunos têm a dizer:',
        },
        recommendedPosts: {
          text: 'Recomendação de posts Nefroupdates',
        },
      },
      nefroupdates: {
        searchBar: {
          placeholder: 'Pesquisar',
        },
      },
    },
    headerData: {
      links: [
        {
          text: 'Quem Somos',
          href: '#quemsomos',
        },
        {
          text: 'Cursos',
          links: [
            // {
            //   text: 'BlackWeek NefroAtual',
            //   href: getPermalink('/cursos/blackweek'),
            // },
            {
              text: 'Injúria Renal Aguda',
              href: getPermalink('/cursos/injuria-renal-aguda'),
            },
            {
              text: 'Doença Renal Crônica 3.0',
              href: getPermalink('/cursos/doenca-renal-cronica'),
            },
            {
              text: 'Consultório',
              href: getPermalink('/cursos/consultorio'),
            },
            {
              text: 'Glomerulopatias 2.0',
              href: getPermalink('/cursos/glomerulopatias'),
            },
            {
              text: 'Distúrbios Hidroeletrolítico',
              href: getPermalink('/cursos/disturbios-hidroeletrolitico'),
            },
            {
              text: 'Prova de Título',
              href: getPermalink('/cursos/prova-de-titulo'),
            },
          ],
        },
        {
          text: 'NefroUpdates',
          href: getPermalink('/nefroupdates'),
          links: [
            { text: 'Tudo', href: getPermalink('/nefroupdates') },
            { text: 'Artigos', href: getPermalink('/nefroupdates/category/Artigos') },
            { text: 'Casos Clínicos', href: getPermalink('/nefroupdates/category/Casos Clínicos') },
            { text: 'Imagens', href: getPermalink('/nefroupdates/category/Imagens') },
            { text: 'Nefrodicas', href: getPermalink('/nefroupdates/category/Nefrodicas') },
            { text: 'Vídeoaulas', href: getPermalink('/nefroupdates/category/Vídeoaulas') },
          ],
        },
        {
          text: 'Calculadoras',
          links: [
            // {
            //   text: 'CalcAtual',
            //   href: getPermalink('/calculadoras/calcatual'),
            // },
            {
              text: 'CKD-EPI',
              href: getPermalink('/calculadoras/ckdepi'),
            },
            {
              text: 'Risco Falência Renal',
              href: getPermalink('/calculadoras/riscofalenciarenal'),
            },
            {
              text: 'IMC e Área Corpórea',
              href: getPermalink('/calculadoras/imc'),
            },
            {
              text: 'Cockcroft & Gault',
              href: getPermalink('/calculadoras/cockcroft'),
            },
          ],
        },
        {
          text: 'Aplicativo',
          href: getPermalink('/aplicativo'),
        },
        // {
        //   text: 'Já sou aluno',
        //   links: [
        //     {
        //       text: 'Injúria Renal Aguda',
        //       href: 'https://injuriarenalaguda.club.hotmart.com/',
        //     },
        //     {
        //       text: 'Doença Renal Crônica',
        //       href: 'https://cursodedoencarenalcronica.club.hotmart.com',
        //     },
        //     {
        //       text: 'Consultório',
        //       href: 'https://nefrologiaparaconsultorio.club.hotmart.com',
        //     },
        //     {
        //       text: 'Glomerulopatias',
        //       href: 'https://glomeruloatual.club.hotmart.com',
        //     },
        //     {
        //       text: 'Distúrbios Hidroeletrolítico',
        //       href: 'https://hidroeletrolitico.club.hotmart.com',
        //     },
        //     {
        //       text: 'Prova de Título',
        //       href: 'https://cursopreparatorioparaprovadeti.club.hotmart.com',
        //     },
        //   ],
        // },
      ],
    },
    footerData: {
      links: [
        {
          title: 'Cursos',
          links: [
            // {
            //   text: 'BlackWeek NefroAtual',
            //   href: getPermalink('/cursos/blackweek'),
            // },
            {
              text: 'Consultório',
              href: getPermalink('/cursos/consultorio'),
            },
            {
              text: 'Distúrbios Hidroeletrolítico',
              href: getPermalink('/cursos/disturbios-hidroeletrolitico'),
            },
            {
              text: 'Doença Renal Crônica 3.0',
              href: getPermalink('/cursos/doenca-renal-cronica'),
            },
            {
              text: 'Glomerulopatias 2.0',
              href: getPermalink('/cursos/glomerulopatias'),
            },
            {
              text: 'Injúria Renal Aguda',
              href: getPermalink('/cursos/injuria-renal-aguda'),
            },
            {
              text: 'Prova de Título',
              href: getPermalink('/cursos/prova-de-titulo'),
            },
          ],
        },
        {
          title: 'Site',
          links: [
            { text: 'Login/Cadastro', href: getPermalink('/signin') },
            { text: 'Quem somos', href: getPermalink('#quemsomos') },
            { text: 'Perguntas frequentes', href: getPermalink('#faq') },
            { text: 'Saiba mais', href: getPermalink('#recursos') },
            { text: 'Aplicativo', href: getPermalink('/aplicativo') },
          ],
        },
        {
          title: 'NefroUpdates',

          links: [
            { text: 'Artigos', href: getPermalink('/nefroupdates/category/Artigos') },
            { text: 'Casos Clínicos', href: getPermalink('/nefroupdates/category/Casos Clínicos') },
            { text: 'Imagens', href: getPermalink('/nefroupdates/category/Imagens') },
            { text: 'Nefrodicas', href: getPermalink('/nefroupdates/category/Nefrodicas') },
            { text: 'Vídeoaulas', href: getPermalink('/nefroupdates/category/Vídeoaulas') },
          ],
        },
        {
          title: 'Redes Sociais',
          links: [
            { text: 'Instagram', href: 'https://www.instagram.com/nefroatual' },
            { text: 'Youtube', href: 'https://www.youtube.com/nefroatual' },
            { text: 'Whatsapp', href: 'https://wa.me/+558132995668' },
          ],
        },
      ],
      secondaryLinks: [
        { text: 'Termos de uso', href: getPermalink('/termos') },
        { text: 'Politica de Privacidade', href: getPermalink('/privacidade') },
      ],
      socialLinks: [
        {
          ariaLabel: 'Instagram',
          icon: 'tabler:brand-instagram',
          href: 'https://www.instagram.com/nefroatual/',
        },
        { ariaLabel: 'Facebook', icon: 'tabler:brand-facebook', href: 'https://facebook.com/nefroatual/' },
        { ariaLabel: 'Whatsapp', icon: 'tabler:brand-whatsapp', href: 'https://wa.me/+558132995668' },
        { ariaLabel: 'Youtube', icon: 'tabler:brand-youtube', href: 'https://youtube.com/nefroatual' },
      ],
    },
    homeData: {
      meta: {
        title: 'NefroAtual - Nefrologia todos os dias',
        description: 'Sua Fonte de Atualizações em Nefrologia Avançada e Prática.',
        dontUseTitleTemplate: true,
      },
      hero: {
        callToAction: {
          text: 'Nossos cursos',
          href: '#cursos',
        },
        callToAction2: {
          text: 'Saiba mais',
          href: '#recursos',
        },
        fragments: {
          image: { html: 'image={{ src: import(~/assets/images/site_imagem1.webp), alt: NefroAtual Hero Image }}' },
          title: {
            html: 'Sua Fonte de <span class="text-accent dark:text-white highlight">Atualizações em Nefrologia</span> Por Quem Faz Todo Dia',
          },
          subtitle: {
            html: '<span class="hidden sm:inline"><span class="font-semibold">Fique por dentro das novidades da Nefrologia</span>, conectando-se com as melhores e mais atuais práticas da nossa especialidade.</span>',
          },
        },
      },
      features: {
        id: 'recursos',
        highlight: 'Atualize-se',
        title: 'Junte-se a nossa Comunidade de Nefrologia',
        subtitle:
          'Faça parte da nossa comunidade digital de nefrologistas e acelere seu desenvolvimento profissional com nossos cursos.',
        items: [
          [
            {
              title: 'Informação na palma da sua mão',
              description:
                'Mantenha-se sempre atualizado com as principais pesquisas que mudam a prática da nefrologia, cuidadosamente selecionadas por nossa equipe.',
              icon: 'tabler:hand-stop',
            },
            {
              title: 'Rede de Profissionais',
              description:
                'Conecte-se com um grupo de profissionais igualmente apaixonados e engajados. É uma oportunidade fantástica para trocar experiências, dicas e conselhos com colegas de todo o país.',
              icon: 'tabler:affiliate',
            },
            {
              title: 'Comunicação Direta',
              description:
                'Nossas redes sociais fornecem um canal direto de comunicação conosco. Se você tiver perguntas, comentários ou feedback, estamos apenas a uma mensagem de distância pelo Instagram ou através do nosso suporte.',
              icon: 'tabler:brand-hipchat',
            },
          ],
          [
            {
              title: 'Educação Continuada de Alta Qualidade',
              description:
                'Nossos cursos são elaborados por especialistas renomados em suas respectivas áreas e são projetados para aprofundar e expandir seu conhecimento.',
              icon: 'tabler:star',
            },
            {
              title: 'Aprendizado Flexível',
              description:
                'Oferecemos uma variedade de formatos de curso para se adequar ao seu estilo de aprendizado e à sua agenda. Aprenda no seu próprio ritmo, quando e onde for melhor para você.',
              icon: 'tabler:device-laptop',
            },
            {
              title: 'Aplicação Prática',
              description:
                'Nossos cursos não se concentram apenas na teoria - eles também oferecem insights valiosos sobre a aplicação prática de novos conhecimentos, para que você possa implementar imediatamente o que aprendeu em sua prática diária.',
              icon: 'tabler:run',
            },
          ],
        ],
      },
      content: {
        id: 'quemsomos',
        highlight: 'Quem somos',
        title: 'A Sua Fonte Confiável de Conhecimento em Nefrologia',
        items: [
          {
            title: 'Educação Continuada',
            description:
              'Nosso compromisso é com a atualização constante. Através do Nefroatual, você terá acesso ao que há de mais novo, relevante e avançado em nefrologia, facilitando a aplicação das melhores práticas em seu atendimento.',
          },
          {
            title: 'Comunidade Engajada',
            description:
              'Priorizamos a interação e troca de experiências. Ao se juntar à nossa comunidade, você ingressa em um grupo que vive a nefrologia diariamente e que é engajada em oferecer o melhor cuidado ao seu paciente.',
          },
          {
            title: 'Liderança',
            description:
              'Sob a coordenação do Professor. Luís Sette, combinamos sua experiência prática e acadêmica como professor universitário e preceptor dos residentes de nefrologia, para proporcionar uma formação de qualidade e atualizada aos alunos Nefroatual',
          },
        ],
        fragments: {
          content: {
            html: `<h2 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descomplicando a Nefrologia</h2>
          Somos uma equipe dedicada a simplificar o aprendizado da nefrologia. Oferecemos cursos online que abordam temas do
          cotidiano nefrológico em uma linguagem clara, acessível e atual.`,
          },
        },
      },
      steps: {
        title: 'Encontre o Curso Ideal em 3 Passos Simples',
        items: [
          {
            title: 'Etapa 1: <span class="font-medium">Navegue pelos Nossos Cursos</span>',
            description:
              'Dê o primeiro passo ao navegar pela nossa variedade de cursos. Verifique os objetivos e conteúdo de cada um para encontrar o que melhor se adapta ao seu interesse.',
            icon: 'tabler:browser-check',
          },
          {
            title: 'Etapa 2: <span class="font-medium">Faça a Escolha Certa</em>',
            description:
              'Com base nas suas necessidades de aprendizado e nos seus objetivos profissionais, escolha o curso que mais se adequa a você. Quer aprimorar um aspecto específico ou expandir seus conhecimentos gerais, temos o que você precisa.',
            icon: 'tabler:check',
          },
          {
            title: 'Etapa 3: <span class="font-medium">Compre com Segurança na Hotmart</span>',
            description:
              'Após escolher o seu curso, você pode realizar a compra de forma segura através da Hotmart, plataforma confiável para venda de cursos online. Com a compra finalizada, você terá acesso total imediato ao conteúdo escolhido!',
            icon: 'tabler:shopping-cart',
          },
        ],
        image: {
          alt: '3 passos',
        },
      },
      cursos: {
        title: 'Nossos cursos',
        subtitle: 'Clique no curso desejado para conhecer mais os detalhes!',
        count: 6,
        postIds: [''],
      },
      faq: {
        title: 'Perguntas Frequentes',
        subtitle: 'Tudo o que Você Precisa Saber Sobre Nossos Cursos',
        highlight: 'Saiba mais',
        items: [
          [
            {
              question: 'Qual é a duração dos cursos?',
              answer:
                'Todos os nossos cursos têm duração de 1 ano. Isso significa que, após a compra, você terá acesso ao material do curso e poderá estudar no seu próprio ritmo durante esse período.',
            },
            {
              question: 'Os cursos têm garantia? Se eu não gostar?',
              answer:
                'Sim, oferecemos uma garantia incondicional de 30 dias. Se por qualquer motivo você decidir que o curso não é adequado para você dentro desse prazo, você poderá solicitar um reembolso total.',
            },
            {
              question: 'Quem ministra os cursos?',
              answer:
                'Todos os nossos cursos são ministrados pelo Dr. Luís Sette, especialista em nefrologia com vasta experiência clínica e acadêmica. O Dr. Luís Sette dedica-se a tornar o aprendizado da nefrologia acessível e compreensível para todos.',
            },
          ],
          [
            {
              question: 'Como posso comprar um curso?',
              answer:
                'A compra pode ser realizada diretamente em nossa plataforma, através da nossa parceria com a Hotmart. Depois de escolher o curso que melhor atende às suas necessidades, basta seguir as instruções na página do curso para finalizar sua compra.',
            },
            {
              question: 'E se eu tiver outras perguntas ou precisar de ajuda?',
              answer:
                'Estamos aqui para ajudar! Se tiver mais perguntas ou precisar de assistência, não hesite em entrar em contato conosco ( pela plataforma do curso na Hotmart, por mensagem no  Instagram do Nefroatual ou pelo nosso suporte pelo WhatsApp). Nosso objetivo é garantir que você tenha uma experiência de aprendizado ativa e enriquecedora.',
            },
            {
              question: 'Os cursos oferecem algum tipo de certificação?',
              answer:
                'Sim, após a conclusão do curso, você receberá um certificado de conclusão para reconhecer seu comprometimento e dedicação ao avanço do seu conhecimento em nefrologia. Este certificado pode ser útil para fins de desenvolvimento profissional contínuo.',
            },
          ],
        ],
      },
      stats: {
        items: [
          { name: 'Seguidores Instagram', value: '+26k' },
          { name: 'Youtube Views', value: '+312k' },
          { name: 'Newsletter', value: '+5K' },
          { name: 'Colaboradores', value: '9' },
        ],
      },
      callToAction: {
        callToAction: {
          text: 'Nossos cursos',
          href: '#cursos',
        },
        fragments: {
          title: { html: '<br class="block sm:hidden" /><span>Dê um Salto na sua Formação</span>' },
          subtitle: {
            html: 'Explore Nossos Cursos Especializados e Inscreva-se Agora para Avançar em sua Carreira e Beneficiar seus Pacientes',
          },
        },
      },
    },
    cursos: {
      consultorioData: {
        meta: {
          title: 'Curso de Consultório',
          priceLink: '#price',
          link: 'https://pay.hotmart.com/H64751402P?off=cu7136uw&checkoutMode=10',
          description: 'Nefrologia para Consultório',
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
        },
        hero2: {
          fragments: {
            title: { html: 'Nefrologia para <span class="text-accent highlight"> Consultório</span>' },
            subtitle: {
              html: '<span>Aprenda a estruturar um consultório de nefrologia de sucesso. Tenha um consultório particular de excelência e mais qualidade de vida, tempo, autonomia e segurança.</span>',
            },
          },
          callToAction: {
            text: 'Quero me inscrever',
          },
        },
        content: {
          items: [
            {
              title:
                'Domine as Práticas Essenciais para Médicos Iniciantes ou Estabelecidos, Garantindo Segurança e Confiança em seu Atendimento',
              description:
                'Curso online focado em desmistificar tudo que envolve a prática do consultório nefrológico. São revisados os principais assuntos para os médicos que já tem o consultório ou para aqueles que desejam iniciar e está inseguro com as práticas atuais.',
            },
            {
              title: 'Abordagem Prática através de Casos Clínicos',
              description:
                'Você vai aprender através de casos clínicos reais, o que precisa para conseguir diagnosticar e tratar seu paciente no consultório.',
            },
            {
              title: 'Suporte e Atualização Constante',
              description:
                'Com base nas recomendações diagnósticas que trouxeram transformações significativas no diagnóstico e tratamento das principais doenças que acometem os doentes renais, fornecemos acompanhamento constante e suporte para esclarecimento de quaisquer dúvidas dos alunos.',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descrição do Curso</h3>
              O que você precisa saber sobre o Curso de Consultório do Nefroatual
            `,
            },
          },
        },
        steps2: {
          title: 'Para quem é o Curso de Consultório?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Médicos Nefrologistas Iniciantes',
              description: 'Para aqueles que desejam iniciar seu consultório particular da maneira correta, deixando os plantões exaustivos para trás.',
            },
            {
              title: 'Nefrologistas Experientes',
              description: 'Para profissionais que já possuem seu próprio consultório e buscam estratégias eficazes para melhorar a captação de pacientes qualificados, aumentando a rentabilidade e eficiência de sua prática.',
            },
            {
              title: 'Nefrologistas em busca de atualização',
              description: 'Para médicos que desejam se manter atualizados com as mais recentes práticas para oferecer um atendimento de excelência aos pacientes.',
            },
            {
              title: 'Residentes em Nefrologia',
              description: 'Para médicos residentes que estão se especializando em nefrologia e já pensam em abrir e estabelecer seu próprio consultório, começando com uma base sólida de conhecimento e prática.',
            },
          ],
          callToAction: {
            title: 'Quero me inscrever',
          },
        },
        steps: {
          title: 'E ainda não acabou, preparamos esses bônus especiais para você:',
          items: [
            {
              title: 'PARA OS 5 PRIMEIROS:',
              description:
                'Mentoria individual com Dr Luís Sette para te auxiliar a montar seu plano de ação para um consultório de sucesso.',
              icon: 'tabler:book',
            },
            {
              title: 'PARA OS 30 PRIMEIROS:',
              description:
                'Mentoria em grupo com Dr. Luís Sette com as estratégias eficazes para ter um consultório particular de excelência.',
              icon: 'tabler:book',
            },
            {
              title: 'Curso Completo de Hipertensão',
              description:
                'São 8 módulos de aulas gravadas com 10 horas de duração que abrange as atualização em hipertensão de acordo com as diretrizes mais atuais de hipertensão',
              icon: 'tabler:video',
            },
            {
              title: 'Curso Completo de Distúrbios Hidroeletrolíticos',
              description:
                'Desenvolva suas Habilidades na Interpretação de Gasometria Arterial e Domine o Diagnóstico e Tratamento de Distúrbios Hidroeletrolíticos e Ácido-Base em Todas as Suas Complexidades de maneira simples',
              icon: 'tabler:video',
            },
            {
              title: 'E-book de distúrbios ácido base',
              description:
                '',
              icon: 'tabler:book',
            },
            {
              title: 'Aulas dos congressos internacionais de 2023 e 2024',
              description:
                'Aulas sobre o melhor conteúdo dos dois congressos internacionais mais relevantes da nossa especialidade!',
              icon: 'tabler:video',
            },
          ],
          image: {
            alt: 'Bônus',
          },
        },
        price: {
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
          // de: 'de R$ 4.497,00',
          price: 'R$ 4.497,00',
          price12x: 'ou em 12x parcelas de R$ 448,82',
          // ate: 'Desconto de R$ 1000,00 apenas no primeiro dia de lançamento do curso',
        },
        modules: [
          {
            name: 'Doença renal crônica',
          },
          {
            name: 'Investigação das Doenças Glomerulares',
          },
          {
            name: 'Doença Renal do Diabetes',
          },
          {
            name: 'Métodos Diagnósticos em Nefrologia',
          },
          {
            name: 'Doença Renal na Gestação',
          },
          {
            name: 'Investigação e Diagnóstico das Tubulopatias',
          },
          {
            name: 'Terapêutica em Nefrologia',
          },
          {
            name: 'Métodos de Imagem em Nefrologia',
          },
          {
            name: 'Avaliação da Função renal e Exame de urina',
          },
          {
            name: 'Nefrolitíase',
          },
          {
            name: 'Infecção do Trato Urinário',
          },
          {
            name: 'Doença Cística Renal',
          },
          {
            name: 'Semiologia em Nefrologia',
          },
        ] as ModuleProps[],
      },
      disturbiosData: {
        meta: {
          title: 'Curso Distúrbios Hidroeletrolíticos',
          priceLink: '#price',
          link: 'https://pay.hotmart.com/F79005801X?checkoutMode=10',
          description: 'Curso Curso Distúrbios Hidroeletrolíticos do Nefroatual',
          subheadline:
            'Desenvolva suas Habilidades na Interpretação de Gasometria Arterial e Domine o Diagnóstico e Tratamento de Distúrbios Hidroeletrolíticos e Ácido-Base em Todas as Suas Complexidades de maneira simples',
        },
        hero2: {
          callToAction: {
            text: 'Quero me inscrever',
          },
          fragments: {
            title: {
              html: 'Curso de <span class="text-accent highlight"> Distúrbios Hidroeletrolíticos</span> do NefroAtual',
            },
            subtitle: {
              html: '<span class="hidden sm:inline">Desenvolva suas Habilidades na Interpretação de Gasometria Arterial e <span class="font-semibold">Domine o Diagnóstico e Tratamento de Distúrbios Hidroeletrolíticos e Ácido-Base</span> em Todas as Suas Complexidades de maneira simples</span>',
            },
          },
        },
        content: {
          items: [
            {
              title: 'Entendendo o curso',
              description:
                'Composto por 21 horas de aula distribuídas em 12 módulos focados em desmistificar tudo que envolve os estes distúrbios. Com uma Abordagem Prática e Descomplicada, você estará Preparado para Diagnosticar e Tratar Essas Condições com segurança',
            },
            {
              title: 'Abordagem Prática através de Casos Clínicos',
              description:
                'Você vai aprender através de casos clínicos reais, o que precisa para conseguir diagnosticar e tratar seu paciente em qualquer ambiente hospitalar (urgências, emergências, enfermarias e em unidades de terapia intensiva)',
            },
            {
              title: 'Suporte e Atualização Constante',
              description:
                'Com base nas recomendações diagnósticas que trouxeram transformações significativas no diagnóstico e tratamento dos DHE AB, fornedemos todo acompanhamento e suporte para esclarecimento de quaisquer dúvidas.',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descrição do Curso</h3>
              O que você precisa saber sobre os Distúrbios Hidroeletrolíticos e Ácido-Base
            `,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o Curso Distúrbios Hidroeletrolíticos?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quero me inscrever',
          },
        },
        content2: {
          items: [
            {
              title: 'Conhecimento Prático',
              description:
                'Nosso Ebook oferece uma abordagem prática e direta, focada na interpretação dos distúrbios ácido-base no contexto clínico, permitindo que você aplique imediatamente essas habilidades no atendimento ao paciente',
            },
            {
              title: 'Orientações Passo a Passo',
              description:
                'Nossas orientações passo a passo ajudam a simplificar a interpretação dos resultados dos testes de gasométricos, permitindo que você identifique rapidamente o tipo de distúrbio presente e tome medidas adequadas',
            },
            {
              title: 'Aplicação Clínica',
              description:
                'Além de fornecer informações teóricas, o Ebook destaca a aplicação clínica dos distúrbios ácido-base em diferentes cenários médicos, fornecendo insights valiosos para a prática à beira do leito',
            },
            {
              title: 'Acessibilidade e Flexibilidade',
              description:
                'Nosso Ebook está disponível em formato digital, permitindo que você acesse o conteúdo em qualquer lugar e a qualquer momento, de acordo com sua conveniência',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Receba ainda esse incrível bônus!</h3>
              Ebook: Interpretação à beira leito dos Distúrbios Ácido-base
            `,
            },
          },
        },
        price: {
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
          price: 'R$ 997,00',
          price12x: 'ou em 12x parcelas de R$ 99,50',
        },
        modules: [
          {
            name: 'Introdução à gasometria e aos DAB',
          },
          {
            name: 'Acidose Metabólica',
          },
          {
            name: 'Alcalose Metabólica',
          },
          {
            name: 'Distúrbios Respiratórios',
          },
          {
            name: 'Avaliação, monitoramento dos distúrbios volêmicos',
          },
          {
            name: 'Hiponatremia',
          },
          {
            name: 'Hipernatremia',
          },
          {
            name: 'Hiperpotassemia',
          },
          {
            name: 'Hipopotassemia',
          },
          {
            name: 'Distúrbios do Cálcio',
          },
          {
            name: 'Distúrbios do Fósforo',
          },
          {
            name: 'Distúrbios do Magnésio',
          },
        ] as ModuleProps[],
      },
      doencaRenalCronicaData: {
        meta: {
          title: 'Curso de Doença Renal Crônica 3.0',
          link: 'https://pay.hotmart.com/P84526915V?off=wzo40nva',
          description: 'Curso de Doença Renal Crônica 3.0 do NefroAtual',
          priceLink: '#price',
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
        },
        hero2: {
          callToAction: {
            text: 'Quero me inscrever',
          },
          fragments: {
            title: { html: `Curso de<span class="text-accent highlight"> Doença Renal Crônica 3.0</span>` },
            subtitle: {
              html: `
              <span class="hidden sm:inline">
                Nosso Curso Abrangente Fornece um <span class="font-semibold"></span>Guia Passo a Passo para Entendimento,
              Abordagem e Manejo</span> desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais
            `,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o Curso de Doença Renal Crônica 3.0?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quero me inscrever',
          },
        },
        steps: {
          title: 'Receba ainda esses incríveis bônus!',
          items: [
            {
              title: 'Curso Hipertensão Arterial Sistêmica ',
              description: 'Com 10 aulas e 8 horas de duração',
              icon: 'tabler:video',
            },
            {
              title: 'E-book ',
              description: 'Manual de doença Renal Crônica na prática clínica',
              icon: 'tabler:book',
            },
            {
              title: 'Aula sobre o KDIGO 2023',
              description: 'As 10 novidades do KDIGO de DRC de 2023 que mudam a prática médica',
              icon: 'tabler:video',
            },
          ],
          image: {
            alt: 'Bônus',
          },
        },
        price: {
          subheadline: 'Atualizado com o novo KDIGO 2023',
          price: 'por R$ 2.497,00 / ano',
          price12x: 'ou em 12x parcelas de R$ 249,21',
        },
        modules: [
          {
            name: 'Definição e Importância da DRC',
          },
          {
            name: 'Estadiamento e Investigação da DRC',
          },
          {
            name: 'Os Big Fours',
          },
          {
            name: 'Retardando a Progressão da DRC',
          },
          {
            name: 'Complicações da DRC',
          },
          {
            name: 'Prevenção da Lesão Renal Aguda',
          },
          {
            name: 'Preparando o Paciente para a TRS',
          },
          {
            name: 'Terapia Renal Substitutiva',
          },
          {
            name: 'Legislação na TRS e tratamento de água',
          },
          {
            name: 'Cuidados Paliativos e Manejo Conservador',
          },
          {
            name: 'DRC na gestação',
          },
        ] as ModuleProps[],
      },
      glomerulopatiasData: {
        meta: {
          title: 'Glomerulopatias 2.0 do NefroAtual',
          link: 'https://pay.hotmart.com/T83633999K?off=zppm151u',
          description: 'GLOMERULOATUAL 2.0',
          subheadline:
            'Descubra como se atualizar da maneira mais eficiente, gastando menos tempo, no diagnóstico, tratamento e prevenção das Glomerulopatias. Desde os princípios fundamentais até as abordagens mais avançadas de tratamento.',
        },
        hero2: {
          callToAction: {
            text: 'QUERO PARTICIPAR',
          },
          fragments: {
            title: { html: `<span class="text-accent highlight">GLOMERULOATUAL 2.0</span>` },
            subtitle: {
              html: `<span>Descubra como se atualizar da maneira mais eficiente, gastando menos tempo, no <span class="font-bold"> diagnóstico, tratamento e prevenção das Glomerulopatias.</span>  Desde os princípios fundamentais até as abordagens mais avançadas de tratamento. <br> <br>Toque no botão abaixo para garantir sua vaga e <span class="font-bold">reduzir anos de experiência para algumas horas de aulas.</span></span>`,
            },
            content: {
              html: `<span class="text-xs justify-center">Compra 100% segura! Receba seu acesso imediatamente após confirmação do pagamento.</span>`,
            },
          },
        },
        features2: {
          title: 'Com o GLOMERULOATUAL 2.0 você:',
          subtitle:
            '',
          items: [
            {
              title: 'Aprenda no Seu Ritmo',
              description:
                'Com total liberdade para estudar quando e onde for conveniente. O curso é completamente adequado para a agenda agitada de um médico e por isso permite que você faça sua própria programação.',
              icon: 'flat-color-icons:clock',
            },
            {
              title: 'Acesso Global',
              description:
                'Independentemente de onde você esteja no mundo, o curso estará ao seu alcance. Tudo que você precisa é de uma conexão com a internet.',
              icon: 'flat-color-icons:touchscreen-smartphone',
            },
            {
              title: 'Conteúdo Atualizado',
              description:
                'Nossa plataforma se mantém atualizada com os avanços mais recentes no campo da nefrologia. Fique por dentro das descobertas e tratamentos mais recentes em medicina renal.',
              icon: 'flat-color-icons:news',
            },
            {
              title: 'Economia Garantida',
              description:
                'Você não precisa gastar com deslocamento, hospedagem e alimentação para se atualizar. GLOMERULOATUAL 2.0 é a melhor - e única - opção de atualização em glomerulopatias para médicos nefrologistas e está a um clique de você.',
              icon: 'flat-color-icons:currency-exchange',
            },
            {
              title: 'Tem um Aprendizado Personalizado',
              description:
                ' Você tem total liberdade para revisitar as aulas e materiais de estudo quantas vezes forem necessárias dentro do período de 1 ano. Nosso curso oferece uma estrutura de aprendizado centrada no aluno, ideal para tópicos complexos em nefrologia.',
              icon: 'flat-color-icons:approval',
            },
            {
              title: 'Recebe Certificado de Conclusão',
              description:
                'Após concluir o curso GLOMERULOATUAL 2.0, você receberá um certificado, demonstrando sua dedicação e conhecimento aprimorado em nefrologia, uma adição valiosa ao seu currículo e perfil profissional.',
              icon: 'flat-color-icons:document',
            },
          ],
        },
        steps2: {
          title: 'Pra quem é?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: 'que querem, através de um especialista nessa área, ter um conhecimento que não tiveram durante a sua formação na residência médica.',
            },
            {
              title: 'Residentes em Nefrologia',
              description: 'que buscam ter segurança para poder cuidar dos meus pacientes com Glomerulopatias.',
            },
            {
              title: 'Médicos Generalistas',
              description: 'que não querem mais que a falta de atualização ou insegurança afetem suas decisões médicas',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: 'que querem se atualizar da maneira mais eficiente, gastando menos tempo, com a melhor referência.',
            },
          ],
          callToAction: {
            text: 'FAZER MINHA INSCRIÇÃO NO CURSO',
          },
        },
        content: {
          items: [
            {
              title: 'Conteúdo de qualidade e de fácil entendimento. Tudo no seu tempo.',
              description:
                'Mais de 50 aulas diretas ao ponto que vão pegar você pela mão - mesmo que você seja iniciante na área de Nefrologia - e te transformar em um profissional seguro e capacitado para oferecer o melhor aos seus pacientes. ',
            },
            {
              title: 'Abordagem Prática através de Casos Clínicos',
              description:
                'Você está prestes a ter acesso ao curso mais completo e atualizado que qualquer faculdade. Fundamentos, Aplicações, Casos Clínicos, Manual Terapêutico. Tudo isso com acesso por 1 ano.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Curso GlomeruloAtual 2.0</h3>`,
            },
          },
        },
        price: {
          subheadline:
            'Curso de atualização constante sobre o diagnóstico, tratamento e prevenção das Glomerulopatias.',
          price: '12 x R$ 349,01 por ano',
          price12x: 'ou R$3.497 a vista',
        },
        modules: [
          {
            name: 'Introdução às Glomerulopatias e Histologia Renal Aplicada',
          },
          {
            name: 'Manejo raciocínio clínico das síndromes glomerulares e biópsia renal ',
          },
          {
            name: 'Doença de Lesões Mínimas',
          },
          {
            name: 'GESF',
          },
          {
            name: 'Glomerulonefrite Membranosa',
          },
          {
            name: 'Nefropatia por IGA',
          },
          {
            name: 'Nefrite Lúpica',
          },
          {
            name: 'GN Rapidamente Progressiva e Vasculites',
          },
          {
            name: 'Glomerulonefrite de Padrão Membranoproliferativo',
          },

          {
            name: 'Amiloidose renal e glomerulopatias raras',
          },
          {
            name: 'Síndrome Hemolítico-Urêmica (SHU e PTT)',
          },
          {
            name: 'Glomerulopatias associadas às infecções',
          },
          {
            name: 'Glomerulopatias pós transplante renal',
          },
          {
            name: 'Glomerulopatia na Gestação',
          },
          {
            name: 'Doença renal do diabetes',
          },
        ] as ModuleProps[],
      },
      injuriaRenalAgudaData: {
        meta: {
          title: 'Curso Injúria Renal Aguda',
          link: 'https://pay.hotmart.com/Y85866611L?off=pm9meeyt',
          description: 'Curso Injúria Renal Aguda',
          priceLink: '#price',
        },
        hero2: {
          callToAction: {
            text: 'Quero me inscrever',
          },
          fragments: {
            title: {
              html: `Diagnóstico e Tratamento da<span class="text-accent highlight"> Injúria Renal Aguda</span>`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Nosso Curso Abrangente Fornece um <span class="font-semibold"></span>Guia Passo a Passo para Entendimento, Abordagem e Manejo</span> desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais`,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o Curso Injúria Renal Aguda?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quero me inscrever',
          },
        },
        steps: {
          title: 'Receba ainda esses incríveis bônus!',
          items: [
            {
              title: 'Ebook: Tudo que você precisa saber para manejar a IRA na beira do leito',
              description:
                'Dê o primeiro passo ao navegar pela nossa variedade de cursos. Verifique os objetivos, conteúdo e qualificações do instrutor de cada um para encontrar o que melhor se adapta ao seu interesse.',
              icon: 'tabler:book',
            },
            {
              title: 'Aulas gravadas da Semana da IRA do Nefroatual',
              description:
                'Com base nas suas necessidades de aprendizado e nos seus objetivos profissionais, escolha o curso que mais se adequa a você. Quer aprimorar um aspecto específico ou expandir seus conhecimentos gerais, temos o que você precisa.',
              icon: 'tabler:video',
            },
          ],
          image: {
            alt: 'Bônus',
          },
        },
        content: {
          items: [
            {
              title: 'Entendendo a Injúria Renal Aguda',
              description:
                'O Curso de IRA do Nefroatual é um curso online focado em desmistificar tudo que envolve a Injúria Renal Aguda.',
            },
            {
              title: 'Abordagem Prática através de Casos Clínicos',
              description:
                'Você vai aprender através de casos clínicos reais, o que precisa para conseguir diagnosticar e tratar seu paciente.',
            },
            {
              title: 'Suporte e Atualização Constante',
              description:
                'Com base nas recomendações diagnósticas que trouxeram transformações significativas no diagnóstico e tratamento diário da IRA, forneço acompanhamento constante e suporte para esclarecimento de quaisquer dúvidas.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descrição do Curso</h3>O que você precisa saber sobre a Injúria Renal Aguda`,
            },
          },
        },
        price: {
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
          de: '',
          price: 'R$ 1.997,00 / ano',
          price12x: 'ou em 12x parcelas de R$ 199,31',
        },
        modules: [
          {
            name: 'Novas definições e critérios diagnósticos',
          },
          {
            name: 'Epidemiologia da IRA no Brasil e no mundo',
          },
          {
            name: 'Fisiopatologia e etiologias da IRA',
          },
          {
            name: 'Avaliação clínica e Laboratorial da IRA',
          },
          {
            name: 'Diagnóstico diferencial da IRA',
          },
          {
            name: 'Tratamento não dialítico e Prevenção da IRA',
          },
          {
            name: 'Suporte renal artificial na IRA',
          },
          {
            name: 'Prognóstico na IRA',
          },
          {
            name: 'Distúrbios ácidos básicos na IRA',
          },
          {
            name: 'Diagnóstico e tratamento dos Distúrbios',
          },
          {
            name: 'Manejo da IRA no pronto socorro',
          },
          {
            name: 'Manejo da IRA na UTI',
          },
          {
            name: 'IRA no paciente com doença hepática crônica',
          },
          {
            name: 'IRA na Oncologia',
          },
          {
            name: 'Rabdomiólise',
          },
          {
            name: 'IRA nefrotóxica',
          },
          {
            name: 'IRA nas doenças Glomerulares',
          },
          {
            name: 'IRA nas doença tropicais',
          },
          {
            name: 'IRA obstrutiva',
          },
          {
            name: 'IRA na gestação',
          },
          {
            name: 'Casos Clínicos em IRA',
          },
        ] as ModuleProps[],
      },
      ofertaUnicaData: {
        meta: {
          title: 'Curso Distúrbios Hidroeletrolíticos',
          priceLink: '#price',
          link: 'https://pay.hotmart.com/F79005801X?checkoutMode=10',
          description: '',
          noindex: true,
        },
        hero2: {
          fragments: {
            title: {
              html: `Curso de <span class="text-accent highlight"> Distúrbios Hidroeletrolíticos</span> do NefroAtual`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Desenvolva suas Habilidades na Interpretação de Gasometria Arterial e <span class="font-semibold">Domine o Diagnóstico e Tratamento de Distúrbios Hidroeletrolíticos e Ácido-Base</span> em Todas as Suas Complexidades de maneira simples</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: 'Entendendo o curso',
              description:
                'Composto por 21 horas de aula distribuídas em 12 módulos focados em desmistificar tudo que envolve os estes distúrbios. Com uma Abordagem Prática e Descomplicada, você estará Preparado para Diagnosticar e Tratar Essas Condições com segurança',
            },
            {
              title: 'Abordagem Prática através de Casos Clínicos',
              description:
                'Você vai aprender através de casos clínicos reais, o que precisa para conseguir diagnosticar e tratar seu paciente em qualquer ambiente hospitalar (urgências, emergências, enfermarias e em unidades de terapia intensiva)',
            },
            {
              title: 'Suporte e Atualização Constante',
              description:
                'Com base nas recomendações diagnósticas que trouxeram transformações significativas no diagnóstico e tratamento dos DHE AB, fornedemos todo acompanhamento e suporte para esclarecimento de quaisquer dúvidas.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descrição do Curso</h3>O que você precisa saber sobre os Distúrbios Hidroeletrolíticos e Ácido-Base`,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o Curso Distúrbios Hidroeletrolíticos?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quero me inscrever',
          },
        },
        content2: {
          items: [
            {
              title: 'Conhecimento Prático',
              description:
                'Nosso Ebook oferece uma abordagem prática e direta, focada na interpretação dos distúrbios ácido-base no contexto clínico, permitindo que você aplique imediatamente essas habilidades no atendimento ao paciente',
            },
            {
              title: 'Orientações Passo a Passo',
              description:
                'Nossas orientações passo a passo ajudam a simplificar a interpretação dos resultados dos testes de gasométricos, permitindo que você identifique rapidamente o tipo de distúrbio presente e tome medidas adequadas',
            },
            {
              title: 'Aplicação Clínica',
              description:
                'Além de fornecer informações teóricas, o Ebook destaca a aplicação clínica dos distúrbios ácido-base em diferentes cenários médicos, fornecendo insights valiosos para a prática à beira do leito',
            },
            {
              title: 'Acessibilidade e Flexibilidade',
              description:
                'Nosso Ebook está disponível em formato digital, permitindo que você acesse o conteúdo em qualquer lugar e a qualquer momento, de acordo com sua conveniência',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Receba ainda esse incrível bônus!</h3>Ebook: Interpretação à beira leito dos Distúrbios Ácido-base`,
            },
          },
        },
        price: {
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
          price: 'R$ 997,00',
          price12x: 'ou em 12x parcelas de R$ 99,50',
        },
        modules: [
          {
            name: 'Introdução à gasometria e aos DAB',
          },
          {
            name: 'Acidose Metabólica',
          },
          {
            name: 'Alcalose Metabólica',
          },
          {
            name: 'Distúrbios Respiratórios',
          },
          {
            name: 'Avaliação, monitoramento dos distúrbios volêmicos',
          },
          {
            name: 'Hiponatremia',
          },
          {
            name: 'Hipernatremia',
          },
          {
            name: 'Hiperpotassemia',
          },
          {
            name: 'Hipopotassemia',
          },
          {
            name: 'Distúrbios do Cálcio',
          },
          {
            name: 'Distúrbios do Fósforo',
          },
          {
            name: 'Distúrbios do Magnésio',
          },
        ] as ModuleProps[],
      },
      provaTituloData: {
        meta: {
          title: 'Curso de Prova de Título',
          link: 'https://pay.hotmart.com/N69833210O?off=c1wmw0uj&checkoutMode=10',
          description: 'Curso de Prova de Título',
          priceLink: '#price',
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
        },
        hero2: {
          callToAction: {
            text: 'Quero garantir minha aprovação',
          },
          fragments: {
            title: {
              html: `Seja aprovado na <span class="text-accent highlight">Prova de Título</span> de Nefrologia`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Nossa metodologia te dá acesso a todo conteúdo necessário para dominar os itens do edital da SBN e obter seu título de especialista em Nefrologia </span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: '19 módulos completos',
              description:
                'Cerca de 85 horas de aulas gravadas cobrindo integralmente o conteúdo do edital.',
            },
            {
              title: 'Material complementar',
              description:
                'Após cada módulo, oferecemos questões para fixação do aprendizado e slides em PDF para anotações pessoais e revisão.',
            },
            {
              title: 'Correção de Simulados mensais ao vivo',
              description:
                'Simulados com questões objetivas e discursivas são corrigidos online ao vivo pelo Dr. Luís Sette.',
            },
             {
              title: 'Flexibilidade de Acesso',
              description:
                'Para aqueles que não podem participar ao vivo, as correções ficam disponíveis gravadas na plataforma para acesso a qualquer momento.',
            },
             {
              title: 'Aplicativo Exclusivo',
              description:
                'Acesse flashcards interativos e um banco de questões através do nosso aplicativo, projetado para reforçar o aprendizado e melhorar a retenção de informações.',
            },
             {
              title: 'Livro físico do Nefroatual',
              description:
                'Você receberá nosso livro físico com todos os insights e conhecimentos necessários para dominar a prova de título.',
            },
             {
              title: 'Grupo no WhatsApp com o professor',
              description:
                'Tire suas dúvidas diretamente com o Dr. Luís Sette e obtenha acompanhamento constante através de nosso grupo exclusivo no WhatsApp.',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Conheça a Metodologia que aprovou 96% dos alunos que concluíram o Curso</h3>
            `,
            },
          },
        },
         content2: {
          items: [
            {
              title: 'São mais de 450 questões divididas em 22 temas para você criar testes personalizados.',
              description:
                '',
            },
            {
              title: 'Com essa ferramenta você pode aumentar muito suas chances de aprovação e ter um índice de acerto altíssimo.',
              description:
                '',
            },
            
        
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">O banco de questões de Nefrologia mais completo e avançado do país:</h3>
            `,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o Curso de Prova de Título?',
          subtitle:
            'Para médicos Nefrogistas que querem ser aprovados na Prova de Título de Especialista em Nefrologia <br> <br>',
          callToAction: {
            text: 'Quero garantir minha aprovação',
          },
        },
        steps: {
          title: 'Receba ainda esses incríveis bônus!',
          items: [
            {
              title: 'Aplicativo com funcionalidades extras',
              description:
                'Com questões comentadas de provas antigas e elaborada pela equipe do Nefroatual para você praticar quando e onde quiser, na palma da sua mão. Flashcards com imagens para você se preparar para as questões mais difíceis e com maior peso de forma mais assertiva.',
              icon: 'tabler:device-mobile',
            },
            {
              title: 'Simulados mensais gravados',
              description:
                'Realizamos simulados com questões objetivas e discursivas com correção online ao vivo mensalmente com Dr. Luís Sette. Para quem não puder participar, estas correções ficarão gravadas na plataforma para serem assistidas quando quiser!',
              icon: 'tabler:video',
            },
            {
              title: 'Grupo de WhatsApp com o professor',
              description:
                'Exclusivo para tirar dúvidas e acesso direto ao professor para não perdemos tempo e acelerar a resposta aos questionamentos.',
              icon: 'tabler:brand-whatsapp',
            },
          ],
          image: {
            alt: 'Bônus',
          },
        },
        price: {
          subheadline: 'Conteúdo Atualizado, Exercícios Práticos e Estratégias de Estudo Personalizadas',          
          price: 'por R$ 5.997,00',
          price12x: 'ou em 12x parcelas de R$ 620,23'
        },
        modules: [
          {
            name: 'Fisiologia Renal',
          },
          {
            name: 'Patologia Renal',
          },
          {
            name: 'Farmacologia em Nefrologia',
          },
          {
            name: 'Métodos Diagnósticos em Nefrologia',
          },
          {
            name: 'Injúria Renal Aguda',
          },
          {
            name: 'Doença Renal Crônica',
          },
          {
            name: 'Terapia Renal Substitutiva',
          },
          {
            name: 'Rim nas Doenças Sistêmicas',
          },
          {
            name: 'Rim na gestação',
          },
          {
            name: 'Glomerulopatias',
          },
          {
            name: 'Tubulopatias e Nefrite Tubulo Intersticial',
          },
          {
            name: 'Doença Cística Renal',
          },
          {
            name: 'Nefrolitíase',
          },
          {
            name: 'Infecção do Trato Urinário',
          },
          {
            name: 'Hipertensão arterial sistêmica',
          },
          {
            name: 'Legislação em Nefrologia',
          },
          {
            name: 'Ética em Nefrologia',
          },
          {
            name: 'Distúrbios ácido básicos',
          },
          {
            name: 'Distúrbios hidroeletrolíticos',
          },
        ] as ModuleProps[],
      },
      blackweekData: {
        meta: {
          title: 'BlackWeek NefroAtual',
          link: '#cursos',
          description: 'BlackWeek do NefroAtual',
          subheadline:
            'Um Guia Passo a Passo para Entendimento, Abordagem e Manejo desta Condição Complexa, com Base nas Práticas e Pesquisas Mais Atuais',
        },
        hero2: {
          callToAction: {
            text: 'QUERO APROVEITAR',
          },
          fragments: {
            title: { html: `BlackWeek do<span class="text-accent highlight"> NefroAtual</span>` },
            subtitle: {
              html: `<span class="hidden sm:inline">Black Week NefroAtual: Quatro Cursos para Dominar a Nefrologia - Doença Renal Crônica 3.0, Injúria Renal Aguda, Distúrbios Hidroeletrolíticos e GlomeruloAtual 2.0</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title:
                'Domine as Práticas Essenciais para Médicos Iniciantes ou Estabelecidos, Garantindo Segurança e Confiança em seu Atendimento',
              description:
                'Curso online focado em desmistificar tudo que envolve a prática do consultório nefrológico. São revisados os principais assuntos para os médicos que já tem o consultório ou para aqueles que desejam iniciar e está inseguro com as práticas atuais.',
            },
            {
              title: 'Abordagem Prática através de Casos Clínicos',
              description:
                'Você vai aprender através de casos clínicos reais, o que precisa para conseguir diagnosticar e tratar seu paciente no consultório.',
            },
            {
              title: 'Suporte e Atualização Constante',
              description:
                'Com base nas recomendações diagnósticas que trouxeram transformações significativas no diagnóstico e tratamento das principais doenças que acometem os doentes renais, fornecemos acompanhamento constante e suporte para esclarecimento de quaisquer dúvidas dos alunos.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Saiba mais sobre os cursos</h3>O que você precisa saber`,
            },
          },
        },
        steps2: {
          title: 'Para quem é?',
          subtitle:
            'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
          callToAction: {
            text: 'QUERO APROVEITAR',
          },
        },
        prices: {
          items: [
            {
              headline: 'Doença Renal Crônica 3.0',
              subheadline: '',
              de: 'de R$ 2.497,00',
              price: 'por R$ 1.897,00',
              price12x: 'ou em 12x parcelas de R$ 189,33',
              link: 'https://pay.hotmart.com/P84526915V?checkoutMode=10',
            },
            {
              headline: 'Curso Injúria Renal Aguda',
              subheadline: '',
              de: 'de R$ 1.997,00',
              price: 'por R$ 1.497,00',
              price12x: 'ou em 12x parcelas de R$ 149,41',
              link: 'https://pay.hotmart.com/Y85866611L?off=sb3er78u&checkoutMode=10',
            },
            {
              headline: 'Curso Distúrbios Hidroeletrolítico',
              subheadline: '',
              de: 'de R$ 997,00',
              price: 'por R$ 749,00',
              price12x: 'ou em 12x parcelas de R$ 74,75',
              link: 'https://pay.hotmart.com/F79005801X?checkoutMode=10',
            },
            {
              headline: 'GlomeruloAtual 2.0',
              subheadline: '',
              de: 'de R$ 3.497',
              price: 'por R$ 2.497,00/ano',
              price12x: 'ou em 12x parcelas de R$ 249,21',
              link: 'https://pay.hotmart.com/T83633999K?off=zppm151u',
            },
          ],
        },
      },
    },
    calculadoras: {
      calcAtual: {
        meta: {
          title: 'CalcAtual - Uma Forma Simples de Estimar o Risco de Falência Renal',
          description: 'Avalie em nossa calculadora o risco do seu paciente',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
        form: {
          age: { label: 'Idade', placeholder: 'Ex: 54' },
          gender: { label: 'Gênero', options: { masculino: 'Masculino', feminino: 'Feminino' } },
          creatinina: { label: 'Creatinina Plasmática (mg/dL)', placeholder: 'Ex: 1.5' },
          albumina: { label: 'Relação Albumina: Creatinina na Urina (mg/g)', placeholder: 'Ex: 80' },
          button: { text: 'Calcular' },
        },
        results: {
          creatinina: 'TFGe Creatinina: ',
          stage: 'Estágio: ',
          risco: 'Risco de progressão para falência renal com necessidade de diálise ou transplante:',
          twoYears: 'Risco do paciente em 2 anos',
          fiveYears: 'Risco do paciente em 5 anos',
          condutas: {
            title: 'Conforme risco podemos adotar as seguintes condutas:',
            items: [
              '• Um risco de insuficiência renal em 5 anos de 3% a 5% pode ser usado para determinar necessidade de encaminhamento para nefrologia',
              '• Um risco de insuficiência renal em 2 anos acima de 10% pode ser usado para determinar o tempo de atendimento multidisciplinar',
              '• Um risco de insuficiência renal de 2 anos acima de 40% pode ser usado para determinar a modalidade, educação e tempo de preparação para a terapia de substituição renal (incluindo planejamento de acesso vascular ou encaminhamento para transplante)',
            ],
          },
          button: { text: 'Recalcular' },
        },
      },
      ckdepi: {
        meta: {
          title: 'CKD-EPI',
          description: 'Avalie em nossa calculadora a função renal do seu paciente',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
      riscofalenciarenal: {
        meta: {
          title: 'Risco Falência Renal',
          description: 'Avalie o Risco de Falência Renal',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
      cockcroft: {
        meta: {
          title: 'Cockcroft & Gault',
          description: 'Avalie em nossa calculadora o risco do seu paciente',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
      imcAsc: {
        meta: {
          title: 'Índice de Massa Corporal + Área da Superfície Corporal',
          description: 'Avalie o Índice de Massa Corporal + Área da Superfície Corporal',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
    },
    doses: {
      dosePage: {
        meta: {
          title: 'Medicaments Register Module',
          description: 'Page to management of medicament registers',
        },
        subtitle: 'Module to the management of the medicaments and doses',
        form: {
          age: { label: 'Idade', placeholder: 'Ex: 54' },
          gender: { label: 'Gênero', options: { masculino: 'Masculino', feminino: 'Feminino' } },
          creatinina: { label: 'Creatinina Plasmática (mg/dL)', placeholder: 'Ex: 1.5' },
          albumina: { label: 'Relação Albumina: Creatinina na Urina (mg/g)', placeholder: 'Ex: 80' },
          button: { text: 'Calcular' },
        },
        results: {
          creatinina: 'TFGe Creatinina: ',
          stage: 'Estágio: ',
          risco: 'Risco de progressão para falência renal com necessidade de diálise ou transplante:',
          twoYears: 'Risco do paciente em 2 anos',
          fiveYears: 'Risco do paciente em 5 anos',
          condutas: {
            title: 'Conforme risco podemos adotar as seguintes condutas:',
            items: [
              '• Um risco de insuficiência renal em 5 anos de 3% a 5% pode ser usado para determinar necessidade de encaminhamento para nefrologia',
              '• Um risco de insuficiência renal em 2 anos acima de 10% pode ser usado para determinar o tempo de atendimento multidisciplinar',
              '• Um risco de insuficiência renal de 2 anos acima de 40% pode ser usado para determinar a modalidade, educação e tempo de preparação para a terapia de substituição renal (incluindo planejamento de acesso vascular ou encaminhamento para transplante)',
            ],
          },
          button: { text: 'Recalcular' },
        },
      },
      ckdepi: {
        meta: {
          title: 'CKD-EPI',
          description: 'Avalie em nossa calculadora a função renal do seu paciente',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
      riscofalenciarenal: {
        meta: {
          title: 'Risco Falência Renal',
          description: 'Avalie o Risco de Falência Renal',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
      cockcroft: {
        meta: {
          title: 'Cockcroft & Gault',
          description: 'Avalie em nossa calculadora o risco do seu paciente',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
      imcAsc: {
        meta: {
          title: 'Índice de Massa Corporal + Área da Superfície Corporal',
          description: 'Avalie o Índice de Massa Corporal + Área da Superfície Corporal',
        },
        subtitle: 'Preencha os campos a seguir para obter uma avaliação do risco do seu paciente',
      },
    },
    aplicativoData: {
      meta: {
        title: 'Aplicativo NefroAtual',
        description: '',
        subheadline:
          'Explore Todo o Universo Nefroatual na Palma da Sua Mão: Acesso Completo a Cursos, Atualizações e ao Nefroupdates em Nosso Aplicativo',
      },
      fragments: {
        title: { html: 'Baixe o <span class="text-accent highlight"> Aplicativo do NefroAtual</span>' },
      },
      steps: {
        title: 'A Nefrologia ao Alcance das Suas Mãos',
        items: [
          {
            title: 'Nefroupdates',
            description:
              'Nunca perca uma atualização importante na nefrologia. Receba notificações em tempo real sobre os mais recentes avanços, estudos e tendências no campo da nefrologia.',
            icon: 'tabler:book',
          },
          {
            title: 'Calculadoras Nefrológicas',
            description:
              'Com base nas suas necessidades de aprendizado e nos seus objetivos profissionais, escolha o curso que mais se adequa a você. Quer aprimorar um aspecto específico ou expandir seus conhecimentos gerais, temos o que você precisa.',
            icon: 'tabler:calculator',
          },
          {
            title: 'Tudo em um',
            description:
              'De cursos educativos a atualizações científicas, nosso aplicativo tem tudo o que um nefrologista precisa em um só lugar. Otimize seu tempo e faça do nosso aplicativo sua ferramenta central de aprendizado e atualização na nefrologia.',
            icon: 'tabler:calculator',
          },
        ],
        image: {
          alt: 'Bônus',
        },
      },
      steps2: {
        title: 'Pra quem é o Aplicativo NefroAtual',
        subtitle:
          'Para profissionais da saúde de diversas áreas que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
        items: [
          {
            title: 'Nefrologistas',
            description: '',
          },
          {
            title: 'Residentes em Nefrologia',
            description: '',
          },
          {
            title: 'Médicos Generalistas',
            description: '',
          },
          {
            title: 'Clínicos e Residentes de Clínica Médica',
            description: '',
          },
        ],
      },
    },
    mapaGlomerulopatiasData: {
      meta: {
        title: 'O Mapa das Glomerulopatias',
      },
      activeCampaign: {
        formValue: '33b33dfe5f0f943fd838e7bb4bc37f05',
        id: '31',
        buttonText: 'Quero Participar',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-7xl text-black">O mapa das <span class="text-accent highlight">Glomerulopatias</span></span>`,
          },
          subtitle: {
            html: `<div><span>Descubra a forma mais atualizada de <span class="font-bold">identificar, diagnosticar e tratar</span> as Glomerulopatias mais comuns na prática clínica.</span><div>16 de abril à 21 de abril - Sempre às 20h | AO VIVO E GRATUITO NO YOUTUBE
</div><span class="font-bold">Inscreva-se gratuitamente.</span></span></div>`,
          },
        },
      },
      other: {
        title: `Prepare-se para uma jornada de aprimoramento em uma área crucial e desafiadora da medicina - as<span class="text-accent highlight"> Glomerulopatias </span>`,
        subtitle: `Neste evento gratuito, você terá a oportunidade de aprofundar seu conhecimento em uma área importante e fundamental para a prática clínica. De forma didática e simples, vou te ensinar um caminho para diagnosticar as glomerulopatias mais comuns e adequar as melhores condutas terapêuticas.
<br> <br>Não deixe que a falta de atualização ou insegurança afetem suas decisões médicas.`,
      },
      hero: {
        fragments: {
          title: { html: ` Para quem é` },
          subtitle: {
            html: `<ul class="text-lg list-disc list-inside pb-10">
              <li>Nefrologistas que atendem em consultórios</li>
              <li>Médicos que atendem interconsultas de Nefrologia;</li>
              <li>Médicos Residentes de Nefrologia;</li>
              <li>Médicos de Residentes de clínica médica.</li>
            </ul>`,
          },
          content: {
            html: `<div class="text-2xl md:text-3xl text-black pb-20">As aulas acontecerão sempre às 20h e não ficarão gravadas, portanto, já bloqueie sua agenda!</div>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'AULA1: PONTO DE PARTIDA',
            description:
              'Como identificar os pacientes com glomerulopatias e dar os primeiros passos no diagnóstico.',
          },
          {
            title: 'AULA 2: PONTO DE PARADA',
            description: 'Como interpretar os principais exames laboratoriais e a biópsia renal.',
          },
          {
            title: 'AULA 3: PERCURSO FINAL',
            description: 'Tratamento geral e específico das glomerulopatias.',
          },
          {
            title: 'AULA 4: ENCONTRANDO O TESOURO',
            description: 'Como ter segurança através de um conhecimento estruturado e específico sobre glomerulopatias.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight sm:text-3xl mb-2">Como vai funcionar</h3>`,
          },
        },
      },
      callToAction: {
        title: 'Preencha seus dados abaixo para se atualizar sobre Glomerulopatias e oferecer aos pacientes o que há de mais atualizado.',
      },
    },
    kdigo2023Data: {
      meta: {
        title: 'Novidades do Kdigo 2023',
      },
      activeCampaign: {
        formValue: '8978ae19332a97846ef546c9bb5dc2ca',
        id: '25',
        buttonText: 'Quero me inscrever',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">As 10 novidades do <span class="text-accent highlight">KDIGO de DRC</span> de 2023 que mudam a prática médica</span>`,
          },
          subtitle: {
            html: `<span>Participe da nossa <span class="font-bold">Aula ao Vivo no dia 13 de Julho às 20:00 no Youtube</span>.<span class="max-md:hidden md:block">Vamos explorar e discutir as principais mudanças trazidas pelo KDIGO 2023. Conteúdo essencial para todos os médicos nefrologistas.</span></span>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'Atualização sobre o KDIGO 2023',
            description: 'Receba informações atualizadas e relevantes sobre o novo KDIGO 2023.',
          },
          {
            title: 'Aprofundamento no Tema',
            description:
              'A aula permitirá uma compreensão mais aprofundada dos tópicos discutidos sobre o KDIGO, com a oportunidade de esclarecer dúvidas em tempo real.',
          },
          {
            title: 'Conforto e Comodidade',
            description:
              'Assista à aula no conforto da sua casa ou de qualquer lugar, sem necessidade de deslocamento.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Nesta aula você obterá:</h3>`,
          },
        },
      },
      steps2: {
        title: `Nosso palestrante:`,
        subtitle: `Dr. Luis Sette é um nefrologista com muitos anos de experiência na área. Sua paixão pela nefrologia e por transmitir conhecimento é evidente em suas palestras engajadoras e informativas. Dr. Sette participou do recente Congresso Europeu de Nefrologia, absorvendo novos insights e descobertas. Ele está ansioso para compartilhar esses conhecimentos na aula ao vivo, guiando os médicos nefrologistas através dos mais recentes desenvolvimentos no campo.`,
        items: [
          {
            // title: 'Experiência',
            description: 'Dr. Sette possui vasta experiência clínica e acadêmica.',
          },
          {
            // title: 'Flexible Team',
            description:
              'Ele é conhecido por sua habilidade de explicar conceitos complexos de forma clara, tornando o aprendizado uma experiência gratificante.',
          },
          {
            // title: 'Ecologic Software',
            description: 'Dr. Sette é um participante ativo de congressos e eventos de nefrologia.',
          },
        ],
      },
      callToAction: {
        title: 'Inscreva-se para descobrir as 10 novidades do KDIGO de DRC de 2023 que mudam a prática médica',
      },
    },
    kdigoIraData: {
      meta: {
        title: 'Novidades do Kdigo de IRA 2023',
      },
      activeCampaign: {
        formValue: 'f7b028354cb3223abc2f3c3bd96d2a0f',
        id: '29',
        buttonText: 'Quero me inscrever',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">As Maiores Mudanças Práticas do <span class="text-accent highlight">KDIGO de IRA 2023</span></span>`,
          },
          subtitle: {
            html: `<span>Participe da nossa <span class="font-bold">Aula ao Vivo às 20:00 no Youtube.</span><span class="max-md:hidden md:block">Vamos explorar e discutir as principais mudanças trazidas pelo KDIGO 2023. Conteúdo essencial para todos os médicos nefrologistas.</span></span>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'Atualização sobre o KDIGO de IRA 2023',
            description: 'Receba informações atualizadas e relevantes sobre o novo KDIGO 2023.',
          },
          {
            title: 'Aprofundamento no Tema',
            description:
              'A aula permitirá uma compreensão mais aprofundada dos tópicos discutidos sobre o KDIGO, com a oportunidade de esclarecer dúvidas em tempo real.',
          },
          {
            title: 'Conforto e Comodidade',
            description:
              'Assista à aula no conforto da sua casa ou de qualquer lugar, sem necessidade de deslocamento.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Nesta aula você obterá:</h3>`,
          },
        },
      },
      steps2: {
        title: `Nosso palestrante:`,
        subtitle: `Dr. Luis Sette é um nefrologista com muitos anos de experiência na área. Sua paixão pela nefrologia e por transmitir conhecimento é evidente em suas palestras engajadoras e informativas. Dr. Sette participou do recente Congresso Europeu de Nefrologia, absorvendo novos insights e descobertas. Ele está ansioso para compartilhar esses conhecimentos na aula ao vivo, guiando os médicos nefrologistas através dos mais recentes desenvolvimentos no campo.`,
        items: [
          {
            // title: 'Experiência',
            description: 'Dr. Sette possui vasta experiência clínica e acadêmica.',
          },
          {
            // title: 'Flexible Team',
            description:
              'Ele é conhecido por sua habilidade de explicar conceitos complexos de forma clara, tornando o aprendizado uma experiência gratificante.',
          },
          {
            // title: 'Ecologic Software',
            description: 'Dr. Sette é um participante ativo de congressos e eventos de nefrologia.',
          },
        ],
      },
      callToAction: {
        title: 'Inscreva-se para descobrir as Maiores novidades do KDIGO de IRA de 2023 que mudam a prática médica',
      },
    },
    obrigadoData: {
      meta: {
        title: 'Obrigado',
      },
      content: {
        title: 'Obrigado',
        success: 'Sua compra foi realizada com sucesso.',
        emailCheck: 'Verifique no seu email as informações sobre o acesso aos cursos.',
        backButton: 'Voltar',
      },
    },
    congressoAmericanoData: {
      meta: {
        title: 'Novidades do Congresso Americano de de Nefrologia',
        description: 'Novidades do Congresso Americano de de Nefrologia 2024',
      },
      activeCampaign: {
        inputHiddenValue: 'f59fe25b2f11f23b1bc32b50c23beead',
        id: '43',
        buttonText: 'FAÇA SUA INSCRIÇÃO PARA PARTICIPAR',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-3xl md:text-4xl text-black">DESTAQUES DO CONGRESSO <span class="text-accent highlight">AMERICANO DE NEFROLOGIA</span></span>`,
          },
          subtitle: {
            html: `
            <span class="font-bold">ATUALIZAÇÕES, REVISÕES E NOVAS CONDUTAS</span>
            <br /><br />
            Esta aula exclusiva oferecerá uma oportunidade de revisar e discutir os pontos mais importantes e relevantes apresentados no congresso americano de Nefrologia 2024 (kidney week)
            <br /><br />
            <span class="font-bold"></span>Dia 05/11 as 20:00h no Youtube.<span class="max-md:hidden md:block"></span>
          `,
          },
        },
      },
      content: {
        items: [
          {
            title:
              'Você já se perguntou quais são as ideias mais importantes e inovadoras discutidas no último Congresso Americano de Nefrologia?  ',
          },
          {
            title:
              'Esta aula exclusiva oferecerá uma oportunidade de revisar e discutir os pontos mais importantes e relevantes apresentados no evento.',
          },
          {
            title:
              'Dr Luis Sette fornece insights atuais e em primeira mão sobre as descobertas mais significativas da Nefrologia.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Sobre a Aula de Revisão</h3>`,
          },
        },
      },
      content2: {
        items: [
          {
            title:
              'Luís Sette é médico nefrologista formado pela USP há 14 anos, com mestrado e doutorado na área. Também é professor adjunto de Nefrologia na Universidade Federal de Pernambuco desde 2014, onde acumulou mais de uma década de experiência na enfermaria de nefrologia, coordenando o cuidado de pacientes internados com as mais diversas doenças glomerulares.',
          },
          {
            title:
              'Atualmente, minha prática médica é no meu consultório privado e ensinando na UFPE para graduandos, internos, residentes de clínica e de nefrologia. ',
          },
          {
            title:
              'Em 2020 iniciamos o projeto NEFROATUAL para democratizar e disseminar o ensino de Nefrologia para todos e possuímos mais de 1200 alunos.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Nosso Palestrante</h3>`,
          },
        },
      },
      steps2: {
        title: `Por que você deve comparecer?`,
        subtitle: ``,
        items: [
          {
            title: 'Se manter atualizado:',
            description:
              'esta aula abrangerá uma ampla gama de tópicos permitindo que você se atualize sobre os últimos estudos da Nefrologia.',
          },
          {
            title: 'Oportunidade Única:',
            description: 'Ter acesso a um conteúdo exclusivo e restrito a poucos profissionais',
          },
          {
            title: 'Materiais de Apoio e Recursos Extras:',
            description: 'Além da aula os inscritos vão receber uma revisão de tudo que vai ser falado no evento.',
          },
        ],
      },
      callToAction: {
        title: 'Inscreva-se para descobrir os maiores DESTAQUES DO CONGRESSO AMERICANO DE NEFROLOGIA',
      },
    },
    congressoEuropeuData: {
      meta: {
        title: 'Novidades do Congresso Europeu de Nefrologia',
        description: 'Novidades do Congresso Europeu de Nefrologia 2024',
      },
      activeCampaign: {
        inputHiddenValue: 'affd90a8623a1ecc10211cab9040d58e',
        id: '27',
        buttonText: 'FAÇA SUA INSCRIÇÃO PARA PARTICIPAR',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">DESTAQUES DO CONGRESSO <span class="text-accent highlight">EUROPEU DE NEFROLOGIA</span></span>`,
          },
          subtitle: {
            html: `
            <span class="font-bold">ATUALIZAÇÕES, REVISÕES E NOVAS CONDUTAS</span>
            <br /><br />
            Esta aula exclusiva oferecerá uma oportunidade de revisar e discutir os pontos mais importantes e relevantes apresentados no congresso Europeu de Nefrologia 2024 
            <br /><br />
            <span class="font-bold"></span>Dia 04/06 as 20:00h no Youtube.<span class="max-md:hidden md:block"></span>
          `,
          },
        },
      },
      content: {
        items: [
          {
            title:
              'Você já se perguntou quais são as ideias mais importantes e inovadoras discutidas no último Congresso Europeu de Nefrologia?  ',
          },
          {
            title:
              'Esta aula exclusiva oferecerá uma oportunidade de revisar e discutir os pontos mais importantes e relevantes apresentados no evento.',
          },
          {
            title:
              'Dr Luis Sette fornece insights atuais e em primeira mão sobre as descobertas mais significativas da Nefrologia.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Sobre a Aula de Revisão</h3>`,
          },
        },
      },
      content2: {
        items: [
          {
            title:
              'Luís Sette é médico nefrologista formado pela USP há 14 anos, com mestrado e doutorado na área. Também é professor adjunto de Nefrologia na Universidade Federal de Pernambuco desde 2014, onde acumulou mais de uma década de experiência na enfermaria de nefrologia, coordenando o cuidado de pacientes internados com as mais diversas doenças glomerulares.',
          },
          {
            title:
              'Atualmente, minha prática médica é no meu consultório privado e ensinando na UFPE para graduandos, internos, residentes de clínica e de nefrologia. ',
          },
          {
            title:
              'Em 2020 iniciamos o projeto NEFROATUAL para democratizar e disseminar o ensino de Nefrologia para todos e possuímos mais de 1200 alunos.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Nosso Palestrante</h3>`,
          },
        },
      },
      steps2: {
        title: `Por que você deve comparecer?`,
        subtitle: ``,
        items: [
          {
            title: 'Se manter atualizado:',
            description:
              'esta aula abrangerá uma ampla gama de tópicos permitindo que você se atualize sobre os últimos estudos da Nefrologia.',
          },
          {
            title: 'Oportunidade Única:',
            description: 'Ter acesso a um conteúdo exclusivo e restrito a poucos profissionais',
          },
          {
            title: 'Materiais de Apoio e Recursos Extras:',
            description: 'Além da aula os inscritos vão receber uma revisão de tudo que vai ser falado no evento.',
          },
        ],
      },
      callToAction: {
        title: 'Inscreva-se para descobrir os maiores DESTAQUES DO CONGRESSO EUROPEU DE NEFROLOGIA',
      },
    },
    confirmacaoData: {
      meta: {
        title: 'Confirmação da Inscrição',
        link: 'https://devzapp.com.br/api-engennier/camp/redirect/64e3add179ec940001364141',
        cta: 'SIM, QUERO ENTRAR NO GRUPO',
      },
      fragment: {
        html: `
          <div class="w-full pt-10 rounded-full px-10">
            <div class="bg-red-600 text-lg font-medium text-white text-center p-1 leading-none rounded-full" style="width: 100%">
              79% Concluído - Atenção! Falta mais um passo!
            </div>
          </div>
        `,
      },
      hero: {
        fragments: {
          title: { html: `Entre no Grupo exclusivo do Whatsapp` },
          subtitle: {
            html: `Então entre no Grupo do WhatsApp, confirme sua inscrição no e-mail que te enviei e prepare-se: A Semana DA NEFROLOGIA AMBULATORIAL começa dia 30 de Julho.`,
          },
          content: { title: 'Todas as informações e materiais importantes serão enviados no Grupo Exclusivo' },
        },
      },
      steps2: {
        title: 'Confirme seu e-mail de cadastro:',
        subtitle: 'Para que você receba todas as minhas comunicações por e-mail sem problemas, é necessário que você confirme o seu e-mail cadastrado. <br><br> Isso sinaliza para a plataforma que você realmente se inscreveu e quer participar da SEMANA DA NEFROLOGIA AMBULATORIAL. <br> <br>Para isso, siga estes passos:',
        items: [
          {
            title: 'Acesse o provedor do e-mail cadastrado;',
            description: 'Preferencialmente o Gmail',
          },
          {
            title: 'Abra o e-mail que acabei de te enviar',
            description:
              'Pode estar na Caixa de Spam ou no Lixo Eletrônico',
          },
          {
            title: 'Aperte no botão “QUERO PARTICIPAR DA SEMANA DA NEFROLOGIA AMBULATORIAL” dentro do e-mail',
            description:
              'Com esses passos simples, você garante que vai receber todos os meus recados — e não vai perder nenhum detalhe das aulas especiais que estou preparando para você.',
          },
        ],
      },
    },
    aulaoData: {
      meta: {
        title: 'Aulão de Revisão para Prova de Título de Nefrologia',
        link: 'https://pay.hotmart.com/H85294483V?off=nlwxcem6',
        description:
          'Serão discutidas as questões e revisados os assuntos mais recorrentes das ultimas provas de forma objetiva e direto ao ponto',
        subheadline: 'Dia 17 de outubro',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">Aulão de Revisão para <span class="text-accent highlight">Prova de Título de Especialista em Nefrologia</span></span>`,
          },
          subtitle: {
            html: `<span class="">Participe do nosso Aulão de véspera no <span class="font-bold">dia 17 de outubro</span>.<span class="max-md:hidden md:block">Serão discutidas as questões e revisados os assuntos mais recorrentes das ultimas provas de forma objetiva e direto ao ponto</span></span>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'Preparação direcionada',
            description:
              'Uma aula especial na véspera para nefrologistas pode direcionar seu estudo para os temas mais relevantes e complexos da prova.',
          },
          {
            title: 'Estratégias',
            description:
              'A aula pode proporcionar estratégias eficazes, como gerenciamento de tempo, dicas para lidar com questões de múltipla escolha e abordagens para responder aos casos clínicos.',
          },
          {
            title: 'Revisão',
            description:
              'Nesta aula, você terá a oportunidade de revisar o conteúdo mais recorrente da prova de título e aumentar suas chances de aprovação',
          },
          {
            title: 'Suporte',
            description:
              'A aula especial pode proporcionar um senso de comunidade e suporte emocional antes do exame. Isso pode ser crucial para o manejo do estresse e da ansiedade relacionados à prova.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Como Vai Ser?</h3>`,
          },
        },
      },
      steps2: {
        title: 'Nosso palestrante:',
        subtitle:
          'Dr. Luis Sette é um nefrologista com muitos anos de experiência na área. Sua paixão pela nefrologia e por transmitir conhecimento é evidente em suas palestras engajadoras e informativas. Dr. Sette participou do recente Congresso Europeu de Nefrologia, absorvendo novos insights e descobertas. Ele está ansioso para compartilhar esses conhecimentos na aula ao vivo, guiando os médicos nefrologistas através dos mais recentes desenvolvimentos no campo.',
        items: [
          {
            // title: 'Experiência',
            description: 'Dr. Sette possui vasta experiência clínica e acadêmica.',
          },
          {
            // title: 'Flexible Team',
            description:
              'Ele é conhecido por sua habilidade de explicar conceitos complexos de forma clara, tornando o aprendizado uma experiência gratificante.',
          },
          {
            // title: 'Ecologic Software',
            description: 'Dr. Sette é um participante ativo de congressos e eventos de nefrologia.',
          },
        ],
      },
      callToAction: {
        text: 'Quero me inscrever',
        price: 'R$ 597,00',
        vagas: 'Até esgotarem as vagas (pelo espaço físico as vagas são limitadas)',
        paymentGatewayText: 'Compre de forma segura pelo hotmart',
      },
    },
    nefroupdates: {
      ofertaData: {
        meta: {
          title: 'Assinatura Anual NefroUpdates',
          subheadline: 'A sua fonte confiável de atualização em Nefrologia!',
          cta: '',
          link: '',
        },
        hero: {
          fragments: {
            title: {
              html: `Sua atualização semanal dos <span class="text-accent highlight">Artigos mais importantes da Nefrologia</span>`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Oferecemos resumos de revisões sobre os principais temas para a prática do nefrologista, auxiliando no aprimoramento contínuo da sua atuação</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: 'Atualização Semanal Imprescindível',
              description:
                'Proporcionamos resumos semanais de artigos práticos recém-publicados em revistas de renome como NEJM, Kidney International, JASN e Guidelines KDIGO.',
            },
            {
              title: 'Compreensão Profunda de Temas Cruciais',
              description:
                'Oferecemos resumos de revisões sobre temas significativos para a prática do nefrologista, auxiliando no aprimoramento contínuo da sua atuação.',
            },
            {
              title: 'Seu Guia Prático',
              description:
                'Apresentamos vídeos curtos com dicas práticas sobre temas que, mesmo não estando nas diretrizes principais, são capazes de transformar suas tomadas de decisão.',
            },
            {
              title: 'Clube de Revista - Discussão e Aprendizado',
              description:
                'Convide-se a participar de discussões enriquecedoras e aprender com os artigos mais importantes da Nefrologia no nosso Clube de Revista.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Veja o que torna o NefroUpdates especial.</h3>Descubra uma experiência de aprendizado inovadora, impulsionada pelas mais recentes pesquisas em Nefrologia.`,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o NefroUpdates?',
          subtitle:
            'Para médicos que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
        },
        content2: {
          image: {
            src: import('~/assets/images/val.webp'),
            alt: 'Valkercyo Feitosa',
          },
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">
                Professor Dr. Valkercyo Feitosa
              </h3>
              Médico nefrologista formado na USP em 2019, doutorando na área de nefropatias hereditárias e professor da Faculdade
              de Medicina de Olinda desde 2022. Atualmente, minha prática médica é o dia a dia do nefrologista, no consultório, clínicas
              de hemodiálise e hospitais universitários. Desde 2022 faço parte do projeto NEFROATUAL para simplificar e tornar a
              Nefrologia de alto nível mais acessível.
            `,
            },
          },
        },
        faqs: {
          title: 'Perguntas Frequentes',
          subtitle: 'Perguntas Frequentes',
          highlight: 'Saiba mais',
          items: [
            [
              {
                question: 'O NefroUpdates têm garantia? Se eu não gostar?',
                answer:
                  'Sim, oferecemos uma garantia incondicional de 30 dias. Se por qualquer motivo você decidir que o curso não é adequado para você dentro desse prazo, você poderá solicitar um reembolso total.',
              },
              {
                question: 'Quem são os autores do material?',
                answer:
                  'Todos os nossos artigos e vídeos são criados por médicos especialistas em nefrologia com vasta experiência clínica e acadêmica. Sendo o Dr. Luís Sette o editor chefe dedicando-se a tornar o aprendizado da nefrologia acessível e compreensível para todos.',
              },
            ],
            [
              {
                question: 'Como posso assinar?',
                answer:
                  'A assinatura pode ser realizada diretamente em nossa plataforma, através da nossa parceria com a Hotmart. Depois de escolher o curso que melhor atende às suas necessidades, basta seguir as instruções na página do curso para finalizar sua compra.',
              },
              {
                question: 'E se eu tiver outras perguntas ou precisar de ajuda?',
                answer:
                  'Estamos aqui para ajudar! Se tiver mais perguntas ou precisar de assistência, não hesite em entrar em contato conosco pelo direct do instagram, plataforma do Hotmart ou também pelo nosso Whatsapp. Nosso objetivo é garantir que você tenha uma experiência de aprendizado suave e enriquecedora.',
              },
            ],
          ],
        },
        steps: {
          title: 'Mantenha-se Atualizado em Qualquer Lugar com Nosso Aplicativo',
          items: [
            {
              title: 'Receba conteúdo exclusivo pelo celular',
              description:
                'Nunca perca uma atualização importante na nefrologia. Receba notificações em tempo real sobre os mais recentes avanços, estudos e tendências no campo da nefrologia.',
              icon: 'tabler:device-mobile',
            },
            {
              title: 'Cobertura Real-Time dos Principais Congressos',
              description:
                'Mantenha-se atualizado em tempo real com a cobertura dos principais congressos nacionais e internacionais, como se você estivesse presente fisicamente.',
              icon: 'tabler:presentation',
            },
            {
              title: 'Grupo Exclusivo do Whatsapp',
              description:
                'Nesse grupo você poderá mandar os seus questionamentos e dúvidas sobre os artigos e vídeos do NefroUpdates, além dos seus casos clínicos para discussão.',
              icon: 'tabler:device-mobile',
            },
             {
              title: 'Acesso a nossas calculadoras',
              description:
                'Calculadoras para ajudar na prática clínica',
              icon: 'tabler:calculator',
            },
          ],
          image: {
            alt: 'Bônus',
          },
        },
      },
      assinaturaData: {
        meta: {
          title: 'Assinatura Anual NefroUpdates',
          link: 'https://pay.hotmart.com/G78906779P?off=fo3g4yii&checkoutMode=10',
          description: 'Aproveite a promoção do Black November',
          subheadline: 'A sua fonte confiável de atualização em Nefrologia!',
          cta: 'FAZER MINHA ASSINATURA',
        },
        hero: {
          fragments: {
            title: {
              html: `Sua atualização semanal dos <span class="text-accent highlight">Artigos mais importantes da Nefrologia</span>`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Oferecemos resumos de revisões sobre os principais temas para a prática do nefrologista, auxiliando no aprimoramento contínuo da sua atuação</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: 'Atualização Semanal Imprescindível',
              description:
                'Proporcionamos resumos semanais de artigos práticos recém-publicados em revistas de renome como NEJM, Kidney International, JASN e Guidelines KDIGO.',
            },
            {
              title: 'Compreensão Profunda de Temas Cruciais',
              description:
                'Oferecemos resumos de revisões sobre temas significativos para a prática do nefrologista, auxiliando no aprimoramento contínuo da sua atuação.',
            },
            {
              title: 'Seu Guia Prático',
              description:
                'Apresentamos vídeos curtos com dicas práticas sobre temas que, mesmo não estando nas diretrizes principais, são capazes de transformar suas tomadas de decisão.',
            },
            {
              title: 'Clube de Revista - Discussão e Aprendizado',
              description:
                'Convide-se a participar de discussões enriquecedoras e aprender com os artigos mais importantes da Nefrologia no nosso Clube de Revista.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Veja o que torna o NefroUpdates especial.</h3>Descubra uma experiência de aprendizado inovadora, impulsionada pelas mais recentes pesquisas em Nefrologia.`,
            },
          },
        },
        steps2: {
          title: 'Pra quem é o NefroUpdates?',
          subtitle:
            'Para médicos que tenham interesse no que há de mais atual sobre Nefrologia e doenças renais. <br> <br>',
          items: [
            {
              title: 'Nefrologistas',
              description: '',
            },
            {
              title: 'Residentes em Nefrologia',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos e Residentes de Clínica Médica',
              description: '',
            },
          ],
        },
        content2: {
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">
                Professor Dr. Valkercyo Feitosa
              </h3>
              Médico nefrologista formado na USP em 2019, doutorando na área de nefropatias hereditárias e professor da Faculdade
              de Medicina de Olinda desde 2022. Atualmente, minha prática médica é o dia a dia do nefrologista, no consultório, clínicas
              de hemodiálise e hospitais universitários. Desde 2022 faço parte do projeto NEFROATUAL para simplificar e tornar a
              Nefrologia de alto nível mais acessível.
            `,
            },
          },
        },
        faqs: {
          title: 'Perguntas Frequentes',
          subtitle: 'Tudo o que Você Precisa Saber Sobre o NefroUpdates',
          highlight: 'Saiba mais',
          items: [
            [
              {
                question: 'O NefroUpdates têm garantia? Se eu não gostar?',
                answer:
                  'Sim, oferecemos uma garantia incondicional de 30 dias. Se por qualquer motivo você decidir que o curso não é adequado para você dentro desse prazo, você poderá solicitar um reembolso total.',
              },
              {
                question: 'Quem são os autores do material?',
                answer:
                  'Todos os nossos artigos e vídeos são criados por médicos especialistas em nefrologia com vasta experiência clínica e acadêmica. Sendo o Dr. Luís Sette o editor chefe dedicando-se a tornar o aprendizado da nefrologia acessível e compreensível para todos.',
              },
            ],
            [
              {
                question: 'Como posso assinar?',
                answer:
                  'A assinatura pode ser realizada diretamente em nossa plataforma, através da nossa parceria com a Hotmart. Depois de escolher o curso que melhor atende às suas necessidades, basta seguir as instruções na página do curso para finalizar sua compra.',
              },
              {
                question: 'E se eu tiver outras perguntas ou precisar de ajuda?',
                answer:
                  'Estamos aqui para ajudar! Se tiver mais perguntas ou precisar de assistência, não hesite em entrar em contato conosco pelo direct do instagram, plataforma do Hotmart ou também pelo nosso Whatsapp. Nosso objetivo é garantir que você tenha uma experiência de aprendizado suave e enriquecedora.',
              },
            ],
          ],
        },
        steps: {
          title: 'Mantenha-se Atualizado em Qualquer Lugar com Nosso Aplicativo',
          items: [
            {
              title: 'Receba conteúdo exclusivo pelo celular',
              description:
                'Nunca perca uma atualização importante na nefrologia. Receba notificações em tempo real sobre os mais recentes avanços, estudos e tendências no campo da nefrologia.',
              icon: 'tabler:device-mobile',
            },
            {
              title: 'Cobertura Real-Time dos Principais Congressos',
              description:
                'Mantenha-se atualizado em tempo real com a cobertura dos principais congressos nacionais e internacionais, como se você estivesse presente fisicamente.',
              icon: 'tabler:presentation',
            },
             {
              title: 'Grupo Exclusivo do Whatsapp',
              description:
                'Nesse grupo você poderá mandar os seus questionamentos e dúvidas sobre os artigos e vídeos do NefroUpdates, além dos seus casos clínicos para discussão.',
              icon: 'tabler:brand-whatsapp',
            },
            {
              title: 'Acesso a nossas calculadoras e o NefroDose',
              description:
                'Você terá acesso a nossas calculadoras para ajudar na prática clínica e a NefroDose para você ajustar a dose dos medicamentos.',
              icon: 'tabler:calculator',
            },
          ],
          image: {
            alt: 'Bônus',
          },
        },
        price: {
          price: 'R$ 1097,00',
          price12x: 'ou em 12x parcelas de R$ 113,46 ',
        },
      },
      postData: {
        dialog: {
          title: 'Conteúdo exclusivo para assinantes',
          description: 'Transforme sua prática clínica com o NefroUpdates.',
          buttons: {
            assinatura: 'Quero saber mais',
            signin: 'Já sou assinante',
          },
        },
      },
    },
    mapaData: {
      meta: {
        title: 'Mapa das Glomerulopatias',
      },
      hero: {
        fragments: {
          title: { html: `O Mapa das <span class="text-accent highlight"> Glomerulopatias</span>` },
          subtitle: {
            html: `<span class="max-h-90">Vamos entender em detalhes desde O Ponto de Partida, ou seja, como identificar o paciente com glomerulopatia e dar os primeiros passos, passando pela interpretação dos exames até o Percurso Final mostrando qual o tratamento geral e específico das Glomerulopatias.</span>`,
          },
        },
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl text-center justifycenter">De 16 a 21 de Abril - Sempre às 20:00</span>`,
          },
          subtitle: {
            html: `
            <div class="flex justify-center space-x-3">
              <a href="#aula1">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 1 <br />Terça 16/04</button>
              </a>
              <a href="#aula2">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 2 <br />Quarta 17/04</button>
              </a>
              <a href="#aula3">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 3 <br /> Quinta 18/04</button>
              </a>
              <a href="#aula4">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 4 <br /> Domingo 21/04</button>
              </a>
            </div>
          `,
          },
          aula1: {
            html: `
            <h2 class="text-lg ">
              <strong>AULA 1: PONTO DE PARTIDA</strong>
              <br />
              <span class="text-left">
              A cada dia, <span class="font-bold">você enfrenta desafios e toma decisões importantes</span> sobre a vida dos seus pacientes. Porém, a velocidade com que as atualizações acontecem somado a um material difícil de ler e de ser encontrado, fica difícil de se atualizar, não é mesmo?. <br><br>É por isso que <span class="font-bold">no primeiro encontro d’O Mapa das Glomerulopatias </span>, te apresento três casos clínicos tratados por mim. De forma simples, mostro como identificar os pacientes com glomerulopatias e dar os primeiros passos no diagnóstico.
              </span>
            </h2><br>
            <span class="p-50">
              <a href="https://drive.google.com/file/d/15Z5al-Myr1yR6iiBuzURSyu1UNZ5s6nc/view?usp=sharing" target="_blank">
                <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded">Baixar Resumo da Aula</button>
              </a>
              <a href="https://devzapp.com.br/api-engennier/camp/redirect/64e3add179ec940001364141" target="_blank">
                <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-4 rounded">Entrar no Grupo do Whatsapp</button>
              </a>
             
            </span><br /><br /><hr /><br />
          `,
          },
          aula2: {
            html: `
            <h2 class="text-lg p-5">
              <strong>AULA 2: PONTO DE PARADA</strong>
              <br />
Sabemos que é <span class="font-bold">essencial entender os mecanismos de diagnóstico das glomerulopatias </span>e interpretar os resultados de forma precisa.<br><br>É por isso que no <span class="font-bold">segundo encontro d’O Mapa das Glomerulopatias</span>, te mostro como <span class="font-bold">interpretar</span> os principais exames laboratoriais e a biópsia renal.
            </h2>
             <span class="p-50">
               <a href="https://drive.google.com/file/d/1Kb_Zk4HDYPfkQZ6xqtJ7SjztinXjpmtE/view?usp=sharing" target="_blank">
                <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded">Baixar Resumo da Aula</button>
              </a>
              <a href="https://devzapp.com.br/api-engennier/camp/redirect/64e3add179ec940001364141" target="_blank">
                <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-4 rounded">Entrar no Grupo do Whatsapp</button>
              </a>
             
            </span>
           <br /><br /><hr /><br />
          `,
          },
          aula3: {
            html: `
            <h2 class="text-lg p-5">
              <strong> AULA 3: PONTO DE CHEGADA</strong>
              <br />
              Existem diversos tratamentos para as Glomerulopatias, mas eu sei que o tempo é curto e não dá para se atualizar o tempo todo.<br><br>É por isso que no <span class="font-bold">terceiro encontro d’O Mapa das Glomerulopatias</span>, de forma prática e simples, eu falo sobre <span class="font-bold">tratamento geral e específico </span>das glomerulopatias.<br><br>Além disso, nessa aula eu te expliquei os detalhes de como você pode ganhar <span class="font-bold">uma vaga para o curso de Glomerulopatias 2.0</span>, e ainda <span class="font-bold">receber um iPad aí na porta da sua casa para facilitar sua prática clínica e ter acesso rápido a informações mais relevantes.</span>

            </h2>
             <a href="https://drive.google.com/file/d/15OT3l_s23XO186uUyJsEmd3Ul9pECebR/view?usp=sharing" target="_blank">
                <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded">Baixar Resumo da Aula</button>
              </a>
              <a href="https://forms.gle/khKNtbL13tfPhKZh9" target="_blank">
              <button type="button" class="bg-red-400 hover:bg-red-700 text-white font-bold py-3 px-4 rounded">Responder o Quiz</button>
            </a>
           <br /><br /><hr /><br />
          `,
          },
          aula4: {
            html: `
            <h2 class="text-lg p-5">
              <strong>AULA 4: ENCONTRANDO O TESOURO</strong>
              <br />
              No quarto e último encontro d’O Mapa das Glomerulopatias, vou te mostrar como ter segurança através de um conhecimento estruturado e específico sobre glomerulopatias. Além disso, é claro, teremos o nosso grande SORTEIO exclusivo para quem acertou no mínimo 70% das questões do QUIZ e estiver presente na aula no domingo, dia 21 de Abril às 20h. 

            </h2>
             
              <a href="https://forms.gle/khKNtbL13tfPhKZh9" target="_blank">
              <button type="button" class="bg-red-400 hover:bg-red-700 text-white font-bold py-3 px-4 rounded">Responder o Quiz</button>
            </a>
           <br /><br /><hr /><br />
           
          `,
          },
        },
      },
    },
    blogData: {
      meta: {
        title: 'Semana da Nefrologia Ambulatorial',
      },
      hero: {
        fragments: {
          title: { html: `Semana da <span class="text-accent highlight"> Nefrologia Ambulatorial</span>` },
          subtitle: {
            html: `<span class="max-h-90">Tudo que você precisa saber para sair dos plantões de nefrologia e montar um consultório de agenda cheia.Tenha mais autonomia, segurança e independência nos tratamentos e fidelize seus pacientes.</span>`,
          },
        },
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl text-center justifycenter">De 21 a 26 de Janeiro - Sempre às 20:00</span>`,
          },
          subtitle: {
            html: `
            <div class="flex justify-center space-x-3">
              <a href="#aula1">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 1 <br />Terça 21/01</button>
              </a>
              <a href="#aula2">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 2 <br />Quarta 22/01</button>
              </a>
              <a href="#aula3">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 3 <br /> Quinta 23/01</button>
              </a>
              <a href="#aula4">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Aula 4 <br /> Domingo 26/01</button>
              </a>
            </div>
          `,
          },
          aula1: {
            html: `
            <h2 class="text-lg uppercase">
              <strong>AULA 1: Porque montar seu próprio consultório </strong>
             
            </h2>
            <span class="p-50">
             
                <a href="https://devzapp.com.br/api-engennier/camp/redirect/64e3add179ec940001364141" target="_blank" >
                <button class="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-4 rounded">Entrar no Grupo do Whatsapp</button>
              </a>
               <a href="/Aula1.pdf" target="_blank">
            <button type="button" class="bg-blue-400 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded">Baixar o PDF da Aula 1</button>
            </a>
            </span><br /><br /><hr /><br />
          `,
          },
          aula2: {
            html: `
            <h2 class="text-lg p-5 uppercase">
              <strong>AULA 2: Preciso investir em marketing para ter um consultório de sucesso?</strong>
              
            </h2>
            <a href="/Aula2.pdf" target="_blank">
          <button type="button" class="bg-blue-400 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded">Baixar o PDF da Aula 2</button>
          </a>
           
             
              
          `,
          //  <a href="/Aula2.pdf" target="_blank">
          //   <button type="button" class="bg-blue-400 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded">Baixar o PDF da Aula 2</button>
          //   </a>
          },
          aula3: {
            //This is the Responder o Quiz Button
            //  <a href="https://forms.gle/wwiBskaujrYu5fyd7" target="_blank">
            //   <button type="button" class="bg-yellow-400 hover:bg-orange-400 text-white font-bold py-3 px-4 rounded">Responder o Quiz</button>
            // </a>
            html: `
            <h2 class="text-lg p-5">
              <strong> AULA 3: <span class="uppercase">Como atrair mais pacientes e precificar sua consulta</span></strong>
              <br />
              
            </h2>
           
             
           <br /><br /><hr /><br />
          `,
          //  <a href="https://forms.gle/wwiBskaujrYu5fyd7" target="_blank">
          //    <button type="button" class="bg-yellow-400 hover:bg-orange-400 text-white font-bold py-3 px-4 rounded">Responder o Quiz</button>
          //   </a>
          //    <a href="/Aula3.pdf" target="_blank">
          //   <button type="button" class="bg-blue-400 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded">Baixar o PDF da Aula 3</button>
          //   </a>
          },
          aula4: {
            html: `
            <h2 class="text-lg p-5 uppercase ">
              <strong>AULA 4: Revisão da semana e sorteio.</strong>
              
            </h2>
           
          `,
          },
        },
      },
    },
  },
  es: {
    components: {
      widgets: {
        beneficts: {
          features2: {
            title: 'Transforma tu Carrera Médica con Nuestros Cursos',
            subtitle:
              'Maximiza tu flexibilidad, accede a contenido actualizado y amplía tus horizontes profesionales, todo a tu propio ritmo.',
            highlight: 'Atención',
            items: [
              {
                title: 'Aprende a tu Ritmo',
                description:
                  'Con nuestros cursos en línea, tienes total libertad para estudiar cuando y donde sea conveniente. Adecuados para la agenda ocupada de un médico, nuestros cursos te permiten establecer tu propio horario.',
                icon: 'flat-color-icons:clock',
              },
              {
                title: 'Acceso Global',
                description:
                  'Independientemente de donde te encuentres en el mundo, nuestros cursos en línea están a tu alcance. Todo lo que necesitas es una conexión a Internet.',
                icon: 'flat-color-icons:touchscreen-smartphone',
              },
              {
                title: 'Contenido Actualizado',
                description:
                  'Nuestra plataforma se mantiene actualizada con los últimos avances en el campo de la nefrología. Mantente al día con los descubrimientos y tratamientos más recientes en medicina renal.',
                icon: 'flat-color-icons:news',
              },
              // {
              //   title: 'Compromiso Interactivo',
              //   description:
              //     'Nuestros cursos no solo presentan materiales de aprendizaje de alta calidad, sino que también ofrecen lugares para resolver dudas para aumentar tu participación y comprensión.',
              //   icon: 'flat-color-icons:assistant',
              // },
              {
                title: 'Economía Garantizada',
                description:
                  'Nuestros cursos en línea son una opción económica. Ahorra en costos de desplazamiento, alojamiento y alimentación e invierte en lo que importa: tu crecimiento profesional.',
                icon: 'flat-color-icons:currency-exchange',
              },
              {
                title: 'Aprendizaje Personalizado',
                description:
                  'Revisa las clases y materiales de estudio tantas veces como quieras y a tu propio ritmo. Nuestros cursos ofrecen una estructura de aprendizaje centrada en el alumno, ideal para temas complejos en nefrología.',
                icon: 'flat-color-icons:approval',
              },
              // {
              //   title: 'Rica Biblioteca de Recursos',
              //   description:
              //     'Complementamos nuestras clases con una variedad de recursos digitales, como videos, podcasts y presentaciones para hacer tu proceso de aprendizaje aún más comprensible e interesante.',
              //   icon: 'flat-color-icons:library',
              // },
              // {
              //   title: 'Red Global de Contactos',
              //   description:
              //     'Únete a una comunidad de profesionales y estudiantes de nefrología de todo el mundo. Amplía tu red y comparte experiencias valiosas con tus colegas.',
              //   icon: 'flat-color-icons:globe',
              // },
              {
                title: 'Certificado de Conclusión',
                description:
                  'Después de completar el curso, recibirás un certificado que demuestra tu dedicación y conocimiento mejorado en nefrología, una adición valiosa a tu currículum y perfil profesional.',
                icon: 'flat-color-icons:document',
              },
            ],
          },
        },
        courseModules: {
          title: 'Descubre Cuáles Son los Módulos del Curso',
          content: 'Todos los módulos contienen preguntas para reforzar el contenido',
          fragments: {
            hours: { pt1: 'Más de', pt2: 'horas de contenido en videoaulas' },
          },
        },
        professor: {
          fragments: {
            content: {
              html: `
            <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Profesor Dr. Luís Sette</h3>
            Me llamo Luís Sette, soy médico nefrólogo y me gradué en la Universidad de São Paulo hace 13 años. 
            Además, cuento con una maestría y un doctorado en el campo de la nefrología. Desde 2014, soy profesor 
            adjunto en la disciplina de Nefrología en la Universidad Federal de Pernambuco.
            En la actualidad, desempeño mi labor médica en mi consultorio privado y enseño en la UFPE a estudiantes 
            de pregrado, internos y residentes de clínica y nefrología. En 2020, iniciamos el proyecto NEFROATUAL 
            con el propósito de democratizar y difundir la enseñanza de la nefrología para todos.
            `,
            },
          },
        },
        courseFAQs: {
          title: 'Preguntas Frecuentes',
          subtitle: 'Todo lo Que Necesitas Saber Sobre Nuestros Cursos',
          highlight: 'Más Información',
          items: [
            [
              {
                question: '¿Cuál es la duración de estos cursos?',
                answer:
                  'Todos nuestros cursos tienen una duración de 1 año. Esto significa que, después de la compra, tendrás acceso al material del curso y podrás estudiar a tu propio ritmo durante ese período.',
              },
              {
                question: '¿Estos cursos tienen garantía? ¿Qué sucede si no me gustan?',
                answer:
                  'Sí, ofrecemos una garantía incondicional de 30 días. Si por alguna razón decides que el curso no es adecuado para ti dentro de ese período, puedes solicitar un reembolso total.',
              },
              {
                question: '¿Quién imparte este curso?',
                answer:
                  'Todos nuestros cursos son impartidos por el Dr. Luís Sette, especialista en nefrología con amplia experiencia clínica y académica. El Dr. Luís Sette se dedica a hacer que el aprendizaje de la nefrología sea accesible y comprensible para todos.',
              },
            ],
            [
              {
                question: '¿Cómo puedo comprar?',
                answer:
                  'La compra se puede realizar directamente en nuestra plataforma, a través de nuestra asociación con Hotmart. Después de elegir el curso que mejor se adapte a tus necesidades, simplemente sigue las instrucciones en la página del curso para finalizar tu compra.',
              },
              {
                question: '¿Y si tengo otras preguntas o necesito ayuda?',
                answer:
                  '¡Estamos aquí para ayudar! Si tienes más preguntas o necesitas asistencia, no dudes en ponerte en contacto con nosotros a través de nuestro directo de Instagram, la plataforma de Hotmart o también por nuestro Whatsapp. Nuestro objetivo es garantizar que tengas una experiencia de aprendizaje fluida y enriquecedora.',
              },
              {
                question: '¿Estos cursos ofrecen algún tipo de certificación?',
                answer:
                  'Sí, después de completar el curso, recibirás un certificado de finalización para reconocer tu compromiso y dedicación al avance de tu conocimiento en nefrología. Este certificado puede ser útil para fines de desarrollo profesional continuo.',
              },
            ],
          ],
        },
        garantia: {
          content: {
            items: [
              {
                title: 'Garantía incondicional',
                description:
                  'No te preocupes por arrepentirte de la inversión. Tienes 30 días completos para probar el contenido y asegurarte de que sea adecuado para ti.',
              },
              {
                title: 'Sin preguntas',
                description:
                  'Si no te gusta, por cualquier motivo, simplemente solicita la devolución de tu inversión y te reembolsaremos. Sin complicaciones ni insistencias.',
              },
            ],
            image: {
              alt: 'Garantía',
            },
            fragments: {
              content: {
                html: `
                <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">
                  No tendrás ningún compromiso financiero en los primeros 30 días
                </h3>`,
              },
            },
          },
        },
        priceDescription: {
          callToAction: {
            text: 'INSCRIBIRME AHORA',
          },
          title: 'Garantía de 30 días o devolución de tu dinero',
          subtitle: 'Compra de forma segura a través de Hotmart',
          image: {
            alt: 'Formas de Pago',
          },
        },
        reviews: {
          title: 'Lo que dicen nuestros estudiantes:',
        },
        recommendedPosts: {
          text: 'Publicaciones recomendadas de Nefroupdates',
        },
      },
      nefroupdates: {
        searchBar: {
          placeholder: 'Buscar',
        },
      },
    },
    headerData: {
      links: [
        {
          text: 'Quienes Somos',
          href: '#quemsomos',
        },
        {
          text: 'Cursos',
          links: [
            // {
            //   text: 'BlackWeek NefroAtual',
            //   href: getPermalink('/cursos/blackweek'),
            // },
            {
              text: 'Lesión renal aguda',
              href: getPermalink('/cursos/injuria-renal-aguda'),
            },
            {
              text: 'Enfermedad Renal Crónica 3.0',
              href: getPermalink('/cursos/doenca-renal-cronica'),
            },
            {
              text: 'Consultorio',
              href: getPermalink('/cursos/consultorio'),
            },
            {
              text: 'Glomerulopatías 2.0',
              href: getPermalink('/cursos/glomerulopatias'),
            },
            {
              text: 'Trastornos Hidroelectrolíticos',
              href: getPermalink('/cursos/disturbios-hidroeletrolitico'),
            },
            // {
            //   text: 'Prueba de Título',
            //   href: getPermalink('/cursos/prova-de-titulo'),
            // },
          ],
        },
        {
          text: 'NefroUpdates',
          href: getPermalink('/nefroupdates'),
          links: [
            { text: 'Tudo', href: getPermalink('/nefroupdates/') },
            { text: 'Artigos', href: getPermalink('/nefroupdates/category/Artigos') },
            { text: 'Casos Clínicos', href: getPermalink('/nefroupdates/category/Casos Clínicos') },
            { text: 'Imagens', href: getPermalink('/nefroupdates/category/Imagens') },
            { text: 'Nefrodicas', href: getPermalink('/nefroupdates/category/Nefrodicas') },
            { text: 'Vídeoaulas', href: getPermalink('/nefroupdates/category/Vídeoaulas') },
          ],
        },
        {
          text: 'Calculadoras',
          links: [
            // {
            //   text: 'CalcAtual',
            //   href: getPermalink('/calculadoras/calcatual'),
            // },
            {
              text: 'CKD-EPI',
              href: getPermalink('/calculadoras/ckdepi'),
            },
            {
              text: 'Riesgo de Insuficiencia Renal',
              href: getPermalink('/calculadoras/riscofalenciarenal'),
            },
            {
              text: 'IMC y Área Corporal',
              href: getPermalink('/calculadoras/imc'),
            },
            {
              text: 'Cockcroft & Gault',
              href: getPermalink('/calculadoras/cockcroft'),
            },
          ],
        },
        {
          text: 'Aplicación',
          href: getPermalink('/aplicativo'),
        },
        // {
        //   text: 'Já sou aluno',
        //   links: [
        //     {
        //       text: 'Injúria Renal Aguda',
        //       href: 'https://injuriarenalaguda.club.hotmart.com/',
        //     },
        //     {
        //       text: 'Doença Renal Crônica',
        //       href: 'https://cursodedoencarenalcronica.club.hotmart.com',
        //     },
        //     {
        //       text: 'Consultório',
        //       href: 'https://nefrologiaparaconsultorio.club.hotmart.com',
        //     },
        //     {
        //       text: 'Glomerulopatias',
        //       href: 'https://glomeruloatual.club.hotmart.com',
        //     },
        //     {
        //       text: 'Distúrbios Hidroeletrolítico',
        //       href: 'https://hidroeletrolitico.club.hotmart.com',
        //     },
        //     {
        //       text: 'Prova de Título',
        //       href: 'https://cursopreparatorioparaprovadeti.club.hotmart.com',
        //     },
        //   ],
        // },
      ],
    },
    footerData: {
      links: [
        {
          title: 'Cursos',
          links: [
            // {
            //   text: 'BlackWeek NefroAtual',
            //   href: getPermalink('/cursos/blackweek'),
            // },
            {
              text: 'Consultorio',
              href: getPermalink('/cursos/consultorio'),
            },
            {
              text: 'Trastornos Hidroelectrolíticos',
              href: getPermalink('/cursos/disturbios-hidroeletrolitico'),
            },
            {
              text: 'Enfermedad Renal Crónica 3.0',
              href: getPermalink('/cursos/doenca-renal-cronica'),
            },
            {
              text: 'Glomerulopatías 2.0',
              href: getPermalink('/cursos/glomerulopatias'),
            },
            {
              text: 'Lesión Renal Aguda',
              href: getPermalink('/cursos/injuria-renal-aguda'),
            },
          ],
        },
        {
          title: 'Sitio',
          links: [
            { text: 'Iniciar Sesión/Registro', href: getPermalink('/signin') },
            { text: 'Quiénes Somos', href: getPermalink('#quemsomos') },
            { text: 'Preguntas Frecuentes', href: getPermalink('#faq') },
            { text: 'Más Información', href: getPermalink('#recursos') },
            { text: 'Aplicación', href: getPermalink('/aplicativo') },
          ],
        },
        {
          title: 'NefroUpdates',

          links: [
            { text: 'Artículos', href: getPermalink('/nefroupdates/category/Articulos') },
            { text: 'Casos Clínicos', href: getPermalink('/nefroupdates/category/Casos%20clinicos') },
            { text: 'Imágenes', href: getPermalink('/nefroupdates/category/Imagenes') },
            { text: 'Nefrodicas', href: getPermalink('/nefroupdates/category/Nefrodicas') },
            { text: 'Vídeo Clases', href: getPermalink('/nefroupdates/category/Video-Clases') },
          ],
        },
        {
          title: 'Redes Sociales',
          links: [
            { text: 'Instagram', href: 'https://www.instagram.com/nefroatual' },
            { text: 'Youtube', href: 'https://www.youtube.com/nefroatual' },
            { text: 'Whatsapp', href: 'https://wa.me/+558132995668' },
          ],
        },
      ],
      secondaryLinks: [
        { text: 'Términos de Uso', href: getPermalink('/termos') },
        { text: 'Política de Privacidad', href: getPermalink('/privacidade') },
      ],
      socialLinks: [
        {
          ariaLabel: 'Instagram',
          icon: 'tabler:brand-instagram',
          href: 'https://www.instagram.com/nefroatual/',
        },
        { ariaLabel: 'Facebook', icon: 'tabler:brand-facebook', href: 'https://facebook.com/nefroatual/' },
        { ariaLabel: 'Whatsapp', icon: 'tabler:brand-whatsapp', href: 'https://wa.me/+558132995668' },
        { ariaLabel: 'Youtube', icon: 'tabler:brand-youtube', href: 'https://youtube.com/nefroatual' },
      ],
    },
    homeData: {
      meta: {
        title: 'NefroAtual - Nefrología todos los días',
        description: 'Tu Fuente de Actualizaciones en Nefrología Avanzada y Práctica.',
        dontUseTitleTemplate: true,
      },
      hero: {
        callToAction: {
          text: 'Nuestros cursos',
          href: '#cursos',
        },
        callToAction2: {
          text: 'Más información',
          href: '#recursos',
        },
        fragments: {
          image: {
            html: 'image={{ src: import(~/assets/images/site_imagem1.webp), alt: Imagen del Héroe de NefroActual }}',
          },
          title: {
            html: 'Tu Fuente de <span class="text-accent dark:text-white highlight">Actualizaciones en Nefrología</span> Hecha por Quienes lo Hacen Todos los Días',
          },
          subtitle: {
            html: '<span class="hidden sm:inline"><span class="font-semibold">Mantente al día con las novedades en Nefrología</span>, conectándote con las mejores y más actuales prácticas de nuestra especialidad.</span>',
          },
        },
      },
      features: {
        id: 'recursos',
        highlight: 'Actualízate',
        title: 'Únete a nuestra Comunidad de Nefrología',
        subtitle:
          'Forma parte de nuestra comunidad digital de nefrólogos y acelera tu desarrollo profesional con nuestros cursos.',
        items: [
          [
            {
              title: 'Información al alcance de tu mano',
              description:
                'Mantente siempre actualizado con las principales investigaciones que cambian la práctica de la nefrología, cuidadosamente seleccionadas por nuestro equipo.',
              icon: 'tabler:hand-stop',
            },
            {
              title: 'Red de Profesionales',
              description:
                'Conéctate con un grupo de profesionales igualmente apasionados y comprometidos. Es una oportunidad fantástica para intercambiar experiencias, consejos y opiniones con colegas de todo el país.',
              icon: 'tabler:affiliate',
            },
            {
              title: 'Comunicación Directa',
              description:
                'Nuestras redes sociales ofrecen un canal directo de comunicación con nosotros. Si tienes preguntas, comentarios o sugerencias, estamos a un mensaje de distancia a través de Instagram o a través de nuestro soporte.',
              icon: 'tabler:brand-hipchat',
            },
          ],
          [
            {
              title: 'Educación Continua de Alta Calidad',
              description:
                'Nuestros cursos son elaborados por expertos de renombre en sus respectivas áreas y están diseñados para profundizar y ampliar tus conocimientos.',
              icon: 'tabler:star',
            },
            {
              title: 'Aprendizaje Flexible',
              description:
                'Ofrecemos una variedad de formatos de curso para adaptarse a tu estilo de aprendizaje y a tu horario. Aprende a tu propio ritmo, cuándo y dónde te resulte más conveniente.',
              icon: 'tabler:device-laptop',
            },
            {
              title: 'Aplicación Práctica',
              description:
                'Nuestros cursos no se centran solo en la teoría, también ofrecen valiosos conocimientos sobre la aplicación práctica de los nuevos conocimientos, para que puedas implementar inmediatamente lo que has aprendido en tu práctica diaria.',
              icon: 'tabler:run',
            },
          ],
        ],
      },
      content: {
        id: 'quemsomos',
        highlight: 'Quiénes somos',
        title: 'Tu Fuente Confiable de Conocimiento en Nefrología',
        items: [
          {
            title: 'Educación Continua',
            description:
              'Nuestro compromiso es la actualización constante. A través de Nefroatual, tendrás acceso a lo más nuevo, relevante y avanzado en nefrología, facilitando la aplicación de las mejores prácticas en tu atención.',
          },
          {
            title: 'Comunidad Comprometida',
            description:
              'Priorizamos la interacción y el intercambio de experiencias. Al unirte a nuestra comunidad, te unes a un grupo que vive la nefrología a diario y que está comprometido en ofrecer la mejor atención a tus pacientes.',
          },
          {
            title: 'Liderazgo',
            description:
              'Bajo la coordinación del Profesor Luís Sette, combinamos su experiencia práctica y académica como profesor universitario y preceptor de residentes de nefrología para proporcionar una formación de calidad y actualizada a los estudiantes de Nefroatual.',
          },
        ],
        fragments: {
          content: {
            html: `<h2 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Simplificando la Nefrología</h2>
          Somos un equipo dedicado a simplificar el aprendizaje de la nefrología. Ofrecemos cursos en línea que abordan temas de la vida cotidiana nefrológica en un lenguaje claro, accesible y actual.`,
          },
        },
      },
      steps: {
        title: 'Encuentra el Curso Ideal en 3 Sencillos Pasos',
        items: [
          {
            title: 'Paso 1: <span class="font-medium">Explora Nuestros Cursos</span>',
            description:
              'Da el primer paso explorando nuestra variedad de cursos. Revisa los objetivos y el contenido de cada uno para encontrar el que mejor se adapte a tus intereses.',
            icon: 'tabler:browser-check',
          },
          {
            title: 'Paso 2: <span class="font-medium">Elige Correctamente</em>',
            description:
              'Basado en tus necesidades de aprendizaje y tus objetivos profesionales, elige el curso que mejor se adapte a ti. Ya sea que desees mejorar un aspecto específico o ampliar tus conocimientos generales, tenemos lo que necesitas.',
            icon: 'tabler:check',
          },
          {
            title: 'Paso 3: <span class="font-medium">Compra de Forma Segura en Hotmart</span>',
            description:
              'Una vez que hayas elegido tu curso, puedes realizar la compra de forma segura a través de Hotmart, una plataforma confiable para la venta de cursos en línea. Con la compra finalizada, tendrás acceso inmediato al contenido seleccionado.',
            icon: 'tabler:shopping-cart',
          },
        ],
        image: {
          alt: '3 pasos',
        },
      },
      cursos: {
        title: 'Nuestros cursos',
        subtitle: '¡Haz clic en el curso deseado para conocer más detalles!',
        count: 6,
        postIds: [''],
      },
      faq: {
        title: 'Preguntas Frecuentes',
        subtitle: 'Todo lo que Necesitas Saber Sobre Nuestros Cursos',
        highlight: 'Más información',
        items: [
          [
            {
              question: '¿Cuál es la duración de los cursos?',
              answer:
                'Todos nuestros cursos tienen una duración de 1 año. Esto significa que, después de la compra, tendrás acceso al material del curso y podrás estudiar a tu propio ritmo durante ese período.',
            },
            {
              question: '¿Los cursos tienen garantía? ¿Y si no me gustan?',
              answer:
                'Sí, ofrecemos una garantía incondicional de 30 días. Si por cualquier motivo decides que el curso no es adecuado para ti dentro de ese período, podrás solicitar un reembolso completo.',
            },
            {
              question: '¿Quiénes imparten los cursos?',
              answer:
                'Todos nuestros cursos son impartidos por el Dr. Luís Sette, especialista en nefrología con una amplia experiencia clínica y académica. El Dr. Luís Sette se dedica a hacer que el aprendizaje de la nefrología sea accesible y comprensible para todos.',
            },
          ],
          [
            {
              question: '¿Cómo puedo comprar un curso?',
              answer:
                'La compra se puede realizar directamente en nuestra plataforma, a través de nuestra asociación con Hotmart. Después de elegir el curso que mejor se adapte a tus necesidades, simplemente sigue las instrucciones en la página del curso para completar tu compra.',
            },
            {
              question: '¿Y si tengo otras preguntas o necesito ayuda?',
              answer:
                '¡Estamos aquí para ayudarte! Si tienes más preguntas o necesitas asistencia, no dudes en ponerte en contacto con nosotros (a través de la plataforma del curso en Hotmart, mediante mensajes en Instagram de Nefroatual o a través de nuestro soporte en WhatsApp). Nuestro objetivo es asegurarnos de que tengas una experiencia de aprendizaje activa y enriquecedora.',
            },
            {
              question: '¿Los cursos ofrecen algún tipo de certificación?',
              answer:
                'Sí, después de completar el curso, recibirás un certificado de finalización para reconocer tu compromiso y dedicación al avance de tus conocimientos en nefrología. Este certificado puede ser útil para el desarrollo profesional continuo.',
            },
          ],
        ],
      },
      stats: {
        items: [
          { name: 'Seguidores en Instagram', value: '+26k' },
          { name: 'Vistas en YouTube', value: '+312k' },
          { name: 'Boletín de noticias', value: '+5K' },
          { name: 'Colaboradores', value: '9' },
        ],
      },
      callToAction: {
        callToAction: {
          text: 'Nuestros cursos',
          href: '#cursos',
        },
        fragments: {
          title: { html: '<br class="block sm:hidden" /><span>Da un Salto en tu Formación</span>' },
          subtitle: {
            html: 'Explora Nuestros Cursos Especializados e Inscríbete Ahora para Avanzar en tu Carrera y Beneficiar a tus Pacientes',
          },
        },
      },
    },
    cursos: {
      consultorioData: {
        meta: {
          title: 'Curso de Consultorio',
          priceLink: '#price',
          link: 'https://pay.hotmart.com/H64751402P?checkoutMode=10',
          description: 'Curso de Consultorio del NefroActual',
          subheadline:
            'Una Guía Paso a Paso para Comprender, Abordar y Gestionar esta Compleja Condición, Basada en las Prácticas e Investigaciones Más Actuales',
        },
        hero2: {
          fragments: {
            title: { html: 'Nefrología para <span class="text-accent highlight"> Consultorio</span>' },
            subtitle: {
              html: '<span class="hidden sm:inline">Nuestro Curso ofrece clases en línea con todos los temas más frecuentes en la consulta de Nefrología para quienes desean actualizarse en la nefrología ambulatoria.</span>',
            },
          },
          callToAction: {
            text: 'Quiero inscribirme',
          },
        },
        content: {
          items: [
            {
              title:
                'Domina las Prácticas Esenciales para Médicos Principiantes o Establecidos, Garantizando Seguridad y Confianza en tu Atención',
              description:
                'Curso en línea enfocado en desmitificar todo lo que implica la práctica en el consultorio nefrológico. Se revisan los temas principales para médicos que ya tienen un consultorio o para aquellos que desean comenzar y se sienten inseguros con las prácticas actuales.',
            },
            {
              title: 'Enfoque Práctico a través de Casos Clínicos',
              description:
                'Aprenderás a través de casos clínicos reales lo que necesitas para diagnosticar y tratar a tus pacientes en la consulta.',
            },
            {
              title: 'Soporte y Actualización Constante',
              description:
                'Basados en las recomendaciones diagnósticas que han traído transformaciones significativas en el diagnóstico y tratamiento de las principales enfermedades renales, proporcionamos un seguimiento constante y apoyo para aclarar cualquier duda de los alumnos.',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descripción del Curso</h3>
              Lo que necesitas saber sobre el Curso de Consultorio del Nefroatual
            `,
            },
          },
        },
        steps2: {
          title: '¿Para quién es el Curso de Consultorio?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina General',
              description: '',
            },
          ],
          callToAction: {
            title: 'Quiero inscribirme',
          },
        },
        steps: {
          title: '¡Recibe estos increíbles bonos!',
          items: [
            {
              title: 'Ebook: Principales Consejos para Montar tu Consultorio',
              description:
                'Aquí te brindo orientación paso a paso de manera objetiva en 10 pasos claros y detallados para montar tu consultorio, desde la elección del lugar hasta la formación de tu equipo, para que minimices tus riesgos e inseguridades.',
              icon: 'tabler:book',
            },
            {
              title: 'Curso de Hipertensión',
              description:
                'Son 8 módulos de clases grabadas con 10 horas de duración que abarcan las actualizaciones sobre hipertensión de acuerdo con las pautas más actuales sobre hipertensión.',
              icon: 'tabler:video',
            },
            {
              title: 'Folleto informativo para pacientes con Enfermedad Renal Crónica e Infección del Tracto Urinario',
              description:
                'Proporciona a tus pacientes información valiosa en formato PDF para que comprendan su enfermedad con un lenguaje menos técnico.',
              icon: 'tabler:book',
            },
            {
              title: 'Clases sobre las actualizaciones del Congreso Americano de 2022 y del Congreso Europeo de 2023',
              description:
                'Clases sobre el mejor contenido de los dos congresos internacionales más relevantes en nuestra especialidad.',
              icon: 'tabler:video',
            },
          ],
          image: {
            alt: 'Bonos',
          },
        },
        price: {
          subheadline:
            'Una Guía Paso a Paso para Comprender, Abordar y Gestionar esta Compleja Condición, Basada en las Prácticas e Investigaciones Más Actuales',
          price: 'R$ 3.497,00',
          price12x: 'o en 12 cuotas de R$ 349,01',
        },
        modules: [
          {
            name: 'Enfermedad Renal Crónica',
          },
          {
            name: 'Investigación de Enfermedades Glomerulares',
          },
          {
            name: 'Enfermedad Renal por Diabetes',
          },
          {
            name: 'Métodos de Diagnóstico en Nefrología',
          },
          {
            name: 'Enfermedad Renal en el Embarazo',
          },
          {
            name: 'Investigación y Diagnóstico de Tubulopatías',
          },
          {
            name: 'Terapéutica en Nefrología',
          },
          {
            name: 'Métodos de Imagen en Nefrología',
          },
          {
            name: 'Evaluación de la Función Renal y Examen de Orina',
          },
          {
            name: 'Nefrolitiasis',
          },
          {
            name: 'Infección del Tracto Urinario',
          },
          {
            name: 'Enfermedad Renal Quística',
          },
          {
            name: 'Semiología en Nefrología',
          },
        ] as ModuleProps[],
      },
      disturbiosData: {
        meta: {
          title: 'Curso de Trastornos Hidroelectrolíticos',
          priceLink: '#price',
          link: 'https://pay.hotmart.com/F79005801X?checkoutMode=10',
          description: 'Curso de Trastornos Hidroelectrolíticos de NefroActual',
          subheadline:
            'Desarrolla tus Habilidades en la Interpretación de la Gasometría Arterial y Domina el Diagnóstico y Tratamiento de Trastornos Hidroelectrolíticos y Ácido-Base en Todas sus Complejidades de manera sencilla',
        },
        hero2: {
          callToAction: {
            text: 'Quiero inscribirme',
          },
          fragments: {
            title: {
              html: 'Curso de <span class="text-accent highlight"> Trastornos Hidroelectrolíticos</span> de NefroActual',
            },
            subtitle: {
              html: '<span class="hidden sm:inline">Desarrolla tus Habilidades en la Interpretación de la Gasometría Arterial y <span class="font-semibold">Domina el Diagnóstico y Tratamiento de Trastornos Hidroelectrolíticos y Ácido-Base</span> en Todas sus Complejidades de manera sencilla</span>',
            },
          },
        },
        content: {
          items: [
            {
              title: 'Entendiendo el curso',
              description:
                'Compuesto por 21 horas de clases distribuidas en 12 módulos enfocados en desmitificar todo lo relacionado con estos trastornos. Con un Enfoque Práctico y Sencillo, estarás Preparado para Diagnosticar y Tratar estas Condiciones con seguridad',
            },
            {
              title: 'Enfoque Práctico a través de Casos Clínicos',
              description:
                'Aprenderás a través de casos clínicos reales lo que necesitas para diagnosticar y tratar a tu paciente en cualquier entorno hospitalario (urgencias, emergencias, enfermerías y unidades de cuidados intensivos)',
            },
            {
              title: 'Soporte y Actualización Constante',
              description:
                'Basados en las recomendaciones diagnósticas que han traído transformaciones significativas en el diagnóstico y tratamiento de los TAE y Ácido-Base, proporcionamos todo el seguimiento y apoyo para aclarar cualquier duda.',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descripción del Curso</h3>
              Lo que necesitas saber sobre los Trastornos Hidroelectrolíticos y Ácido-Base
            `,
            },
          },
        },
        steps2: {
          title: '¿Para quién es el Curso de Trastornos Hidroelectrolíticos?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina General',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quiero inscribirme',
          },
        },
        content2: {
          items: [
            {
              title: 'Conocimiento Práctico',
              description:
                'Nuestro Ebook ofrece un enfoque práctico y directo, centrado en la interpretación de los trastornos ácido-base en el contexto clínico, permitiéndote aplicar inmediatamente estas habilidades en la atención al paciente',
            },
            {
              title: 'Orientaciones Paso a Paso',
              description:
                'Nuestras orientaciones paso a paso ayudan a simplificar la interpretación de los resultados de las pruebas gasométricas, permitiéndote identificar rápidamente el tipo de trastorno presente y tomar medidas adecuadas',
            },
            {
              title: 'Aplicación Clínica',
              description:
                'Además de proporcionar información teórica, el Ebook destaca la aplicación clínica de los trastornos ácido-base en diferentes escenarios médicos, proporcionando información valiosa para la práctica junto a la cama del paciente',
            },
            {
              title: 'Accesibilidad y Flexibilidad',
              description:
                'Nuestro Ebook está disponible en formato digital, lo que te permite acceder al contenido en cualquier lugar y en cualquier momento, según tu conveniencia',
            },
          ],
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">¡Recibe este increíble bono adicional!</h3>
              Ebook: Interpretación junto a la cama de los Trastornos Ácido-Base
            `,
            },
          },
        },
        price: {
          subheadline:
            'Un Guía Paso a Paso para Comprender, Abordar y Manejar esta Compleja Condición, Basada en las Prácticas e Investigaciones Más Actuales',
          price: 'R$ 997,00',
          price12x: 'o en 12 cuotas de R$ 99,50',
        },
        modules: [
          {
            name: 'Introducción a la gasometría y a los TAE',
          },
          {
            name: 'Acidosis Metabólica',
          },
          {
            name: 'Alcalosis Metabólica',
          },
          {
            name: 'Trastornos Respiratorios',
          },
          {
            name: 'Evaluación y monitorización de los trastornos del volumen',
          },
          {
            name: 'Hiponatremia',
          },
          {
            name: 'Hipernatremia',
          },
          {
            name: 'Hiperpotasemia',
          },
          {
            name: 'Hipopotasemia',
          },
          {
            name: 'Trastornos del Calcio',
          },
          {
            name: 'Trastornos del Fósforo',
          },
          {
            name: 'Trastornos del Magnesio',
          },
        ] as ModuleProps[],
      },
      doencaRenalCronicaData: {
        meta: {
          title: 'Curso de Enfermedad Renal Crónica 3.0',
          link: 'https://pay.hotmart.com/P84526915V?off=wzo40nva',
          description: 'Curso de Enfermedad Renal Crónica 3.0 de NefroActual',
          priceLink: '#price',
          subheadline:
            'Una Guía Paso a Paso para Comprender, Abordar y Gestionar esta Compleja Condición, Basada en las Prácticas e Investigaciones Más Actuales',
        },
        hero2: {
          callToAction: {
            text: 'Quiero inscribirme',
          },
          fragments: {
            title: { html: `Curso de<span class="text-accent highlight"> Enfermedad Renal Crónica 3.0</span>` },
            subtitle: {
              html: `
              <span class="hidden sm:inline">
                Nuestro Curso Integral Ofrece una <span class="font-semibold"></span>Guía Paso a Paso para Comprender,
                Abordar y Gestionar</span> esta Compleja Condición, Basada en las Prácticas e Investigaciones Más Actuales
              `,
            },
          },
        },
        steps2: {
          title: '¿Para quién es el Curso de Enfermedad Renal Crónica 3.0?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina General',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quiero inscribirme',
          },
        },
        steps: {
          title: '¡Recibe estos increíbles bonos!',
          items: [
            {
              title: 'Curso de Hipertensión Arterial Sistémica',
              description: 'Con 10 clases y 8 horas de duración',
              icon: 'tabler:video',
            },
            {
              title: 'E-book',
              description: 'Manual de Enfermedad Renal Crónica en la práctica clínica',
              icon: 'tabler:book',
            },
            {
              title: 'Clase sobre el KDIGO 2023',
              description: 'Las 10 novedades del KDIGO de ERC de 2023 que cambian la práctica médica',
              icon: 'tabler:video',
            },
          ],
          image: {
            alt: 'Bonos',
          },
        },
        price: {
          subheadline: 'Actualizado con el nuevo KDIGO 2023',
          price: 'por R$ 2.497,00 / año',
          price12x: 'o en 12 cuotas de R$ 249,21',
        },
        modules: [
          {
            name: 'Definición e Importancia de la ERC',
          },
          {
            name: 'Estadificación e Investigación de la ERC',
          },
          {
            name: 'Los Cuatro Grandes',
          },
          {
            name: 'Retardar la Progresión de la ERC',
          },
          {
            name: 'Complicaciones de la ERC',
          },
          {
            name: 'Prevención de la Lesión Renal Aguda',
          },
          {
            name: 'Preparando al Paciente para la TRS',
          },
          {
            name: 'Terapia Renal Sustitutiva',
          },
          {
            name: 'Legislación en la TRS y tratamiento del agua',
          },
          {
            name: 'Cuidados Paliativos y Manejo Conservador',
          },
          {
            name: 'ERC en el embarazo',
          },
        ] as ModuleProps[],
      },
      glomerulopatiasData: {
        meta: {
          title: 'Glomerulopatias 2.0 de NefroActual',
          link: 'https://pay.hotmart.com/T83633999K?off=zppm151u',
          description: 'Curso de Glomerulopatias 2.0 de NefroActual',
          subheadline:
            'Curso de actualización constante sobre el diagnóstico, tratamiento y prevención de las Glomerulopatias. Desde los principios fundamentales hasta enfoques de tratamiento más avanzados.',
        },
        hero2: {
          callToAction: {
            text: 'INSCRIBIRME EN EL CURSO',
          },
          fragments: {
            title: { html: `Curso de <span class="text-accent highlight">Glomerulopatias 2.0</span> de NefroActual` },
            subtitle: {
              html: `<span><span class="font-semibold">Curso de actualización constante sobre el diagnóstico, tratamiento y prevención de las Glomerulopatias.</span> Desde los principios fundamentales hasta enfoques de tratamiento más avanzados.</span>`,
            },
            content: {
              html: `<span class="text-xs justify-center">¡Compra 100% segura! Recibe tu acceso inmediatamente después de confirmar el pago.</span>`,
            },
          },
        },
        features2: {
          title: '¿QUÉ ES EL CURSO GLOMERULOACTUAL 2.0?',
          subtitle:
            'El Curso de Glomerulopatias es el lugar donde encontrarás todo sobre las Glomerulopatias de la forma más actualizada posible. Desde los principios básicos hasta enfoques más avanzados.',
          highlight: 'Atención',
          items: [
            {
              title: 'Aprende a tu Ritmo',
              description:
                'Con nuestros cursos en línea, tienes total libertad para estudiar cuando y donde te resulte conveniente. Adecuado para la apretada agenda de un médico, nuestros cursos te permiten crear tu propia programación.',
              icon: 'flat-color-icons:clock',
            },
            {
              title: 'Acceso Global',
              description:
                'Independientemente de dónde te encuentres en el mundo, nuestros cursos en línea están a tu alcance. Todo lo que necesitas es una conexión a Internet.',
              icon: 'flat-color-icons:touchscreen-smartphone',
            },
            {
              title: 'Contenido Actualizado',
              description:
                'Nuestra plataforma se mantiene al día con los avances más recientes en el campo de la nefrología. Mantente al tanto de los descubrimientos y tratamientos más recientes en medicina renal.',
              icon: 'flat-color-icons:news',
            },
            {
              title: 'Ahorro Garantizado',
              description:
                'Nuestros cursos en línea son una opción económica. Ahorra en costos de desplazamiento, alojamiento y alimentación, e invierte en lo que realmente importa: tu crecimiento profesional.',
              icon: 'flat-color-icons:currency-exchange',
            },
            {
              title: 'Aprendizaje Personalizado',
              description:
                'Revisa las clases y materiales de estudio tantas veces como desees y a tu propio ritmo. Nuestros cursos ofrecen una estructura de aprendizaje centrada en el estudiante, ideal para temas complejos en nefrología.',
              icon: 'flat-color-icons:approval',
            },
            {
              title: 'Certificado de Finalización',
              description:
                'Después de completar el curso, recibirás un certificado que demuestra tu dedicación y mejora en el conocimiento de nefrología, una valiosa adición a tu currículum y perfil profesional.',
              icon: 'flat-color-icons:document',
            },
          ],
        },
        steps2: {
          title: '¿Para quién es el Curso GlomeruloActual 2.0?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina General',
              description: '',
            },
          ],
          callToAction: {
            text: 'INSCRIBIRME EN EL CURSO',
          },
        },
        content: {
          items: [
            {
              title: 'Contenido de calidad y fácil de entender. Todo a tu propio ritmo.',
              description:
                'Más de 50 clases directas y concisas que te guiarán, incluso si eres un principiante en el campo de la nefrología, y te convertirán en un profesional seguro y capacitado para ofrecer lo mejor a tus pacientes.',
            },
            {
              title: 'Enfoque Práctico a través de Casos Clínicos',
              description:
                'Estás a punto de acceder al curso más completo y actualizado que cualquier facultad. Fundamentos, Aplicaciones, Casos Clínicos, Manual Terapéutico. Todo esto con acceso durante 1 año.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Curso GlomeruloActual 2.0</h3>`,
            },
          },
        },
        price: {
          subheadline:
            'Curso de actualización constante sobre el diagnóstico, tratamiento y prevención de las Glomerulopatias.',
          price: '12 x R$ 299,11 por año',
          price12x: 'o R$2.997 al contado',
        },
        modules: [
          {
            name: 'Introducción a las Glomerulopatias y Histología Renal Aplicada',
          },
          {
            name: 'Manejo y razonamiento clínico de las síndromes glomerulares y biopsia renal',
          },
          {
            name: 'Enfermedad de Lesiones Mínimas',
          },
          {
            name: 'GESF',
          },
          {
            name: 'Glomerulonefritis Membranosa',
          },
          {
            name: 'Nefropatía por IGA',
          },
          {
            name: 'Nefritis Lúpica',
          },
          {
            name: 'GN Rápidamente Progresiva y Vasculitis',
          },
          {
            name: 'Glomerulonefritis de Patrón Membranoproliferativo',
          },
          {
            name: 'Amiloidosis renal y glomerulopatias raras',
          },
          {
            name: 'Síndrome Hemolítico-Urémico (SHU y PTT)',
          },
          {
            name: 'Glomerulopatias asociadas a infecciones',
          },
          {
            name: 'Glomerulopatias post trasplante renal',
          },
          {
            name: 'Glomerulopatia en el Embarazo',
          },
          {
            name: 'Enfermedad Renal del Diabetes',
          },
        ] as ModuleProps[],
      },
      injuriaRenalAgudaData: {
        meta: {
          title: 'Curso de Insuficiencia Renal Aguda',
          link: 'https://pay.hotmart.com/Y85866611L?off=pm9meeyt',
          description: 'Curso de Insuficiencia Renal Aguda',
          priceLink: '#price',
        },
        hero2: {
          callToAction: {
            text: 'Quiero inscribirme',
          },
          fragments: {
            title: {
              html: `Diagnóstico y Tratamiento de la<span class="text-accent highlight"> Insuficiencia Renal Aguda</span>`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Nuestro Curso Integral Ofrece una <span class="font-semibold"></span>Guía Paso a Paso para la Comprensión, Enfoque y Manejo</span> de esta Condición Compleja, Basada en las Prácticas e Investigaciones Más Actuales`,
            },
          },
        },
        steps2: {
          title: '¿Para quién es el Curso de Insuficiencia Renal Aguda?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina General',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quiero inscribirme',
          },
        },
        steps: {
          title: '¡Recibe estos increíbles bonos!',
          items: [
            {
              title: 'Ebook: Todo lo que necesitas saber para manejar la IRA en el lecho del paciente',
              description:
                'Da el primer paso explorando nuestra variedad de cursos. Consulta los objetivos, contenido y calificaciones del instructor de cada uno para encontrar el que mejor se adapte a tus intereses.',
              icon: 'tabler:book',
            },
            {
              title: 'Clases grabadas de la Semana de la IRA de NefroActual',
              description:
                'Basado en tus necesidades de aprendizaje y tus objetivos profesionales, elige el curso que mejor se adapte a ti. Ya sea que desees mejorar un aspecto específico o ampliar tus conocimientos generales, tenemos lo que necesitas.',
              icon: 'tabler:video',
            },
          ],
          image: {
            alt: 'Bonos',
          },
        },
        content: {
          items: [
            {
              title: 'Comprendiendo la Insuficiencia Renal Aguda',
              description:
                'El Curso de IRA de NefroActual es un curso en línea enfocado en desmitificar todo lo relacionado con la Insuficiencia Renal Aguda.',
            },
            {
              title: 'Enfoque Práctico a través de Casos Clínicos',
              description:
                'Aprenderás a través de casos clínicos reales lo que necesitas para diagnosticar y tratar a tu paciente.',
            },
            {
              title: 'Soporte y Actualización Constante',
              description:
                'Basado en las recomendaciones diagnósticas que han traído transformaciones significativas en el diagnóstico y tratamiento diario de la IRA, brindo un seguimiento constante y soporte para aclarar cualquier duda.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descripción del Curso</h3>Lo que necesitas saber sobre la Insuficiencia Renal Aguda`,
            },
          },
        },
        price: {
          subheadline:
            'Una Guía Paso a Paso para la Comprensión, Enfoque y Manejo de esta Condición Compleja, Basada en las Prácticas e Investigaciones Más Actuales',
          de: '',
          price: 'R$ 1.997,00 por año',
          price12x: 'o en 12 cuotas de R$ 199,31',
        },
        modules: [
          {
            name: 'Nuevas definiciones y criterios diagnósticos',
          },
          {
            name: 'Epidemiología de la IRA en Brasil y en el mundo',
          },
          {
            name: 'Fisiopatología y etiologías de la IRA',
          },
          {
            name: 'Evaluación clínica y laboratorial de la IRA',
          },
          {
            name: 'Diagnóstico diferencial de la IRA',
          },
          {
            name: 'Tratamiento no dialítico y Prevención de la IRA',
          },
          {
            name: 'Soporte renal artificial en la IRA',
          },
          {
            name: 'Pronóstico en la IRA',
          },
          {
            name: 'Trastornos ácido-base en la IRA',
          },
          {
            name: 'Diagnóstico y tratamiento de los Trastornos',
          },
          {
            name: 'Manejo de la IRA en el servicio de urgencias',
          },
          {
            name: 'Manejo de la IRA en la UCI',
          },
          {
            name: 'IRA en pacientes con enfermedad hepática crónica',
          },
          {
            name: 'IRA en Oncología',
          },
          {
            name: 'Rabdomiólisis',
          },
          {
            name: 'IRA nefrotóxica',
          },
          {
            name: 'IRA en enfermedades Glomerulares',
          },
          {
            name: 'IRA en enfermedades tropicales',
          },
          {
            name: 'IRA obstructiva',
          },
          {
            name: 'IRA en la gestación',
          },
          {
            name: 'Casos Clínicos en IRA',
          },
        ] as ModuleProps[],
      },
      ofertaUnicaData: {
        meta: {
          title: 'Curso de Trastornos Hidroelectrolíticos',
          priceLink: '#price',
          link: 'https://pay.hotmart.com/F79005801X?checkoutMode=10',
          description: '',
          noindex: true,
        },
        hero2: {
          fragments: {
            title: {
              html: `Curso de <span class="text-accent highlight"> Trastornos Hidroelectrolíticos</span> de NefroActual`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Desarrolle sus habilidades en la interpretación de la Gasometría Arterial y <span class="font-semibold">Domine el diagnóstico y tratamiento de los Trastornos Hidroelectrolíticos y Ácido-Base</span> en todas sus complejidades de manera sencilla</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: 'Comprendiendo el curso',
              description:
                'Compuesto por 21 horas de clases distribuidas en 12 módulos centrados en desmitificar todo lo relacionado con estos trastornos. Con un enfoque práctico y descomplicado, estarás preparado para diagnosticar y tratar estas condiciones con seguridad',
            },
            {
              title: 'Enfoque Práctico a través de Casos Clínicos',
              description:
                'Aprenderás a través de casos clínicos reales lo que necesitas para diagnosticar y tratar a tu paciente en cualquier entorno hospitalario (urgencias, emergencias, salas de hospitalización y unidades de cuidados intensivos)',
            },
            {
              title: 'Soporte y Actualización Constante',
              description:
                'Basado en las recomendaciones diagnósticas que han traído transformaciones significativas en el diagnóstico y tratamiento de los Trastornos Hidroelectrolíticos y Ácido-Base, brindamos todo el seguimiento y apoyo para aclarar cualquier duda.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descripción del Curso</h3>Lo que necesitas saber sobre los Trastornos Hidroelectrolíticos y Ácido-Base`,
            },
          },
        },
        steps2: {
          title: '¿Para quién es el Curso de Trastornos Hidroelectrolíticos?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina General',
              description: '',
            },
          ],
          callToAction: {
            text: 'Quiero inscribirme',
          },
        },
        content2: {
          items: [
            {
              title: 'Conocimiento Práctico',
              description:
                'Nuestro Ebook ofrece un enfoque práctico y directo, centrado en la interpretación de los trastornos ácido-base en el contexto clínico, lo que te permite aplicar de inmediato estas habilidades en la atención al paciente',
            },
            {
              title: 'Instrucciones Paso a Paso',
              description:
                'Nuestras instrucciones paso a paso ayudan a simplificar la interpretación de los resultados de las pruebas de gasometría, lo que te permite identificar rápidamente el tipo de trastorno presente y tomar medidas adecuadas',
            },
            {
              title: 'Aplicación Clínica',
              description:
                'Además de proporcionar información teórica, el Ebook destaca la aplicación clínica de los trastornos ácido-base en diferentes escenarios médicos, brindando valiosos conocimientos para la práctica en el lecho del paciente',
            },
            {
              title: 'Accesibilidad y Flexibilidad',
              description:
                'Nuestro Ebook está disponible en formato digital, lo que te permite acceder al contenido en cualquier lugar y en cualquier momento, según tu conveniencia',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">¡Recibe este increíble bono adicional!</h3>Ebook: Interpretación en el lecho del paciente de los Trastornos Ácido-Base`,
            },
          },
        },
        price: {
          subheadline:
            'Una Guía Paso a Paso para la Comprensión, Enfoque y Manejo de esta Condición Compleja, Basada en las Prácticas e Investigaciones Más Actuales',
          price: 'R$ 997,00',
          price12x: 'o en 12 cuotas de R$ 99,50',
        },
        modules: [
          {
            name: 'Introducción a la gasometría y los Trastornos Ácido-Base',
          },
          {
            name: 'Acidosis Metabólica',
          },
          {
            name: 'Alcalosis Metabólica',
          },
          {
            name: 'Trastornos Respiratorios',
          },
          {
            name: 'Evaluación y monitorización de los trastornos de volumen',
          },
          {
            name: 'Hiponatremia',
          },
          {
            name: 'Hipernatremia',
          },
          {
            name: 'Hiperpotasemia',
          },
          {
            name: 'Hipopotasemia',
          },
          {
            name: 'Trastornos del Calcio',
          },
          {
            name: 'Trastornos del Fósforo',
          },
          {
            name: 'Trastornos del Magnesio',
          },
        ] as ModuleProps[],
      },
      blackweekData: {
        meta: {
          title: 'BlackWeek NefroAtual',
          link: '#cursos',
          description: 'BlackWeek de NefroAtual',
          subheadline:
            'Una Guía Paso a Paso para la Comprensión, Enfoque y Manejo de esta Condición Compleja, basada en las Prácticas e Investigaciones más Actuales',
        },
        hero2: {
          callToAction: {
            text: 'QUIERO APROVECHAR',
          },
          fragments: {
            title: { html: `BlackWeek de<span class="text-accent highlight">NefroAtual</span>` },
            subtitle: {
              html: `<span class="hidden sm:inline">Black Week NefroAtual: Cuatro Cursos para Dominar la Nefrología - Enfermedad Renal Crónica 3.0, Lesión Renal Aguda, Trastornos Hidroelectrolíticos y GlomeruloAtual 2.0</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title:
                'Domine las Prácticas Esenciales para Médicos Principiantes o Establecidos, Asegurando Seguridad y Confianza en su Atención',
              description:
                'Curso en línea enfocado en desmitificar todo lo que involucra la práctica del consultorio nefrológico. Se revisan los temas principales para los médicos que ya tienen el consultorio o para aquellos que desean comenzar y se sienten inseguros con las prácticas actuales.',
            },
            {
              title: 'Enfoque Práctico a través de Casos Clínicos',
              description:
                'Aprenderá a través de casos clínicos reales lo que necesita para diagnosticar y tratar a su paciente en el consultorio.',
            },
            {
              title: 'Soporte y Actualización Constante',
              description:
                'Basados en las recomendaciones diagnósticas que han traído transformaciones significativas en el diagnóstico y tratamiento de las principales enfermedades que afectan a los pacientes renales, proporcionamos seguimiento constante y soporte para aclarar cualquier duda de los alumnos.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2"> Más información sobre los cursos</h3>Lo que necesita saber`,
            },
          },
        },
        steps2: {
          title: '¿Para quién es?',
          subtitle:
            'Para profesionales de la salud de diversas áreas que tengan interés en lo más actual sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina Interna',
              description: '',
            },
          ],
          callToAction: {
            text: 'QUIERO APROVECHAR',
          },
        },
        prices: {
          items: [
            {
              headline: 'Enfermedad Renal Crónica 3.0',
              subheadline: '',
              de: 'de R$ 2,497.00',
              price: 'por R$ 1,897.00',
              price12x: 'o en 12 cuotas de R$ 189.33',
              link: 'https://pay.hotmart.com/P84526915V?checkoutMode=10',
            },
            {
              headline: 'Curso Lesión Renal Aguda',
              subheadline: '',
              de: 'de R$ 1,997.00',
              price: 'por R$ 1,497.00',
              price12x: 'o en 12 cuotas de R$ 149.41',
              link: 'https://pay.hotmart.com/Y85866611L?off=sb3er78u&checkoutMode=10',
            },
            {
              headline: 'Curso Trastornos Hidroelectrolíticos',
              subheadline: '',
              de: 'de R$ 997.00',
              price: 'por R$ 749.00',
              price12x: 'o en 12 cuotas de R$ 74.75',
              link: 'https://pay.hotmart.com/F79005801X?checkoutMode=10',
            },
            {
              headline: 'GlomeruloAtual 2.0',
              subheadline: '',
              de: 'de R$ 3,497.00',
              price: 'por R$ 2,497.00/ano',
              price12x: 'o en 12 cuotas de R$ 249.21',
              link: 'https://pay.hotmart.com/T83633999K?off=zppm151u',
            },
          ],
        },
      },
    },
    calculadoras: {
      calcAtual: {
        meta: {
          title: 'CalcAtual - Una Forma Sencilla de Estimar el Riesgo de Insuficiencia Renal.',
          description: 'Evalúe en nuestra calculadora el riesgo de su paciente',
        },
        subtitle: 'Complete los campos a continuación para obtener una evaluación del riesgo de su paciente',
        form: {
          age: { label: 'Edad', placeholder: 'Ej: 54' },
          gender: { label: 'Género', options: { masculino: 'Masculino', feminino: 'Femenino' } },
          creatinina: { label: 'Creatinina Plasmática (mg/dL)', placeholder: 'Ej: 1.5' },
          albumina: { label: 'Relación Albumina: Creatinina en la Orina (mg/g)', placeholder: 'Ej: 80' },
          button: { text: 'Calcular' },
        },
        results: {
          creatinina: 'TFGe Creatinina: ',
          stage: 'Etapa: ',
          risco: 'Riesgo de progresión a insuficiencia renal con necesidad de diálisis o trasplante:',
          twoYears: 'Riesgo del paciente en 2 años',
          fiveYears: 'Riesgo del paciente en 5 años',
          condutas: {
            title: 'Conforme al riesgo, podemos adoptar las siguientes conductas:',
            items: [
              '• Un riesgo de insuficiencia renal en 5 años del 3% al 5% puede usarse para determinar la necesidad de remisión a nefrología',
              '• Un riesgo de insuficiencia renal en 2 años superior al 10% puede usarse para determinar el tiempo de atención multidisciplinaria',
              '• Un riesgo de insuficiencia renal en 2 años superior al 40% puede usarse para determinar la modalidad, educación y tiempo de preparación para la terapia de reemplazo renal (incluyendo planificación de acceso vascular o remisión para trasplante)',
            ],
          },
          button: { text: 'Recalcular' },
        },
      },
      ckdepi: {
        meta: {
          title: 'CKD-EPI',
          description: 'Evalúe en nuestra calculadora la función renal de su paciente',
        },
        subtitle: 'Complete los campos a continuación para obtener una evaluación del riesgo de su paciente',
      },
      riscofalenciarenal: {
        meta: {
          title: 'Riesgo Falencia Renal',
          description: 'Evalúe el Riesgo de Falencia Renal',
        },
        subtitle: 'Complete los campos a continuación para obtener una evaluación del riesgo de su paciente',
      },
      cockcroft: {
        meta: {
          title: 'Cockcroft & Gault',
          description: 'Evalúe en nuestra calculadora el riesgo de su paciente',
        },
        subtitle: 'Complete los campos a continuación para obtener una evaluación del riesgo de su paciente',
      },
      imcAsc: {
        meta: {
          title: 'Índice de Masa Corporal + Área de Superficie Corporal',
          description: 'Evalúe el Índice de Masa Corporal + Área de Superficie Corporal',
        },
        subtitle: 'Complete los campos a continuación para obtener una evaluación del riesgo de su paciente',
      },
    },
    aplicativoData: {
      meta: {
        title: 'Aplicación NefroActual',
        description: '',
        subheadline:
          'Explora Todo el Universo NefroActual en la Palma de tu Mano: Acceso Completo a Cursos, Actualizaciones y a NefroUpdates en Nuestra Aplicación',
      },
      fragments: {
        title: { html: 'Descarga la <span class="text-accent highlight">Aplicación de NefroActual</span>' },
      },
      steps: {
        title: 'Nefrología al Alcance de tus Manos',
        items: [
          {
            title: 'NefroUpdates',
            description:
              'Nunca te pierdas una actualización importante en nefrología. Recibe notificaciones en tiempo real sobre los últimos avances, estudios y tendencias en el campo de la nefrología.',
            icon: 'tabler:book',
          },
          {
            title: 'Calculadoras Nefrológicas',
            description:
              'Según tus necesidades de aprendizaje y tus objetivos profesionales, elige el curso que mejor se adapte a ti. Ya sea para mejorar un aspecto específico o ampliar tus conocimientos generales, tenemos lo que necesitas.',
            icon: 'tabler:calculator',
          },
          {
            title: 'Todo en Uno',
            description:
              'Desde cursos educativos hasta actualizaciones científicas, nuestra aplicación tiene todo lo que un nefrólogo necesita en un solo lugar. Optimiza tu tiempo y convierte nuestra aplicación en tu herramienta central de aprendizaje y actualización en nefrología.',
            icon: 'tabler:calculator',
          },
        ],
        image: {
          alt: 'Bonificación',
        },
      },
      steps2: {
        title: 'Para Quiénes es la Aplicación NefroActual',
        subtitle:
          'Para profesionales de la salud de diversas áreas que estén interesados en lo más actual sobre nefrología y enfermedades renales. <br> <br>',
        items: [
          {
            title: 'Nefrólogos',
            description: '',
          },
          {
            title: 'Residentes en Nefrología',
            description: '',
          },
          {
            title: 'Médicos Generalistas',
            description: '',
          },
          {
            title: 'Clínicos y Residentes de Medicina Interna',
            description: '',
          },
        ],
      },
    },
    mapaGlomerulopatiasData: {
      meta: {
        title: 'El Mapa de las Glomerulopatías',
      },
      activeCampaign: {
        formValue: '33b33dfe5f0f943fd838e7bb4bc37f05',
        id: '31',
        buttonText: 'Quiero inscribirme',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-7xl text-black">El mapa de las <span class="text-accent highlight">Glomerulopatías</span></span>`,
          },
          subtitle: {
            html: `<div><span>El Dr. Luís Sette enseñará de manera didáctica y sencilla un enfoque para <span class="font-bold">Diagnosticar las Glomerulopatías más comunes y Ajustar las Mejores Conductas Terapéuticas.</span><div>Del 26 de septiembre al 1 de octubre - Siempre a las 20:00</div><span class="font-bold">Inscríbete de forma gratuita.</span></span></div>`,
          },
        },
      },
      other: {
        title: `Aprende cómo Identificar, Diagnosticar y Tratar las <span class="text-accent highlight">Glomerulopatías más Comunes en la Práctica Clínica</span>`,
        subtitle: `No te pierdas esta gran oportunidad de actualizarte sobre las Glomerulopatías y ofrecer a los pacientes lo más actualizado.`,
      },
      hero: {
        fragments: {
          title: { html: `¿Por qué el Mapa?` },
          subtitle: {
            html: `<span class="font-semibold">El Dr. Luís presentará 3 casos clínicos y mostrará el camino desde el Punto de Partida - Cómo identificar a los pacientes con glomerulopatías y dar los primeros pasos en el diagnóstico, pasando por la interpretación de los exámenes hasta el Recorrido Final con el tratamiento general y específico de las Glomerulopatías.<br /><br /></span>`,
          },
          content: {
            html: `
            <h3 class="text-2xl font-bold tracking-tight sm:text-3xl mb-2">ENCUENTRO EXCLUSIVO PARA MÉDICOS:</h3>
            <ul class="text-lg list-disc list-inside pb-10">
              <li>Nefrólogos que atienden en consultorios</li>
              <li>Nefrólogos que atienden pacientes en urgencias y emergencias</li>
              <li>Residentes de Nefrología</li>
              <li>Residentes de medicina interna y clínicos ya graduados que atienden pacientes en consultorios o unidades de hospitalización</li>
            </ul>
          `,
          },
        },
      },
      content: {
        items: [
          {
            title: 'CLASE 1: PUNTO DE PARTIDA',
            description:
              'Cómo identificar al paciente con glomerulopatía y dar los primeros pasos hacia el diagnóstico',
          },
          {
            title: 'CLASE 2: PUNTO DE DETENCIÓN',
            description: 'Cómo interpretar las pruebas de laboratorio principales y la biopsia renal',
          },
          {
            title: 'CLASE 3: RECORRIDO FINAL',
            description: 'Tratamiento general y específico de las glomerulopatías',
          },
          {
            title: 'CLASE 4: ENCONTRANDO EL TESORO',
            description: 'Cómo mantenerte actualizado el 100% del tiempo y ofrecer lo mejor a tus pacientes',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Saldrás de este encuentro más seguro y sabiendo cómo diagnosticar y tratar las principales glomerulopatías.</h3>`,
          },
        },
      },
      callToAction: {
        title: 'Inscríbete en El Mapa de las Glomerulopatías',
      },
    },
    kdigo2023Data: {
      meta: {
        title: 'Novedades del KDIGO 2023',
      },
      activeCampaign: {
        formValue: '8978ae19332a97846ef546c9bb5dc2ca',
        id: '25',
        buttonText: 'Quiero inscribirme',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">Las 10 novedades del <span class="text-accent highlight">KDIGO de ERC</span> de 2023 que cambian la práctica médica</span>`,
          },
          subtitle: {
            html: `<span>Participa en nuestra <span class="font-bold">Clase en Vivo el 13 de julio a las 20:00 en YouTube</span>.<span class="max-md:hidden md:block">Exploraremos y discutiremos los principales cambios que trae el KDIGO 2023. Contenido esencial para todos los médicos nefrólogos.</span></span>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'Actualización sobre el KDIGO 2023',
            description: 'Recibe información actualizada y relevante sobre el nuevo KDIGO 2023.',
          },
          {
            title: 'Profundización en el Tema',
            description:
              'La clase permitirá una comprensión más profunda de los temas discutidos en el KDIGO, con la oportunidad de aclarar dudas en tiempo real.',
          },
          {
            title: 'Comodidad y Conveniencia',
            description:
              'Mira la clase desde la comodidad de tu hogar o cualquier otro lugar, sin necesidad de desplazarte.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">En esta clase obtendrás:</h3>`,
          },
        },
      },
      steps2: {
        title: `Nuestro orador:`,
        subtitle: `El Dr. Luis Sette es un nefrólogo con muchos años de experiencia en el campo. Su pasión por la nefrología y por transmitir conocimiento es evidente en sus charlas atractivas e informativas. El Dr. Sette participó en el reciente Congreso Europeo de Nefrología, adquiriendo nuevos conocimientos e ideas. Está ansioso por compartir estos conocimientos en la clase en vivo, guiando a los nefrólogos a través de los desarrollos más recientes en el campo.`,
        items: [
          {
            // title: 'Experiencia',
            description: 'El Dr. Sette tiene una amplia experiencia clínica y académica.',
          },
          {
            // title: 'Flexible Team',
            description:
              'Es conocido por su habilidad para explicar conceptos complejos de manera clara, lo que hace que el aprendizaje sea una experiencia gratificante.',
          },
          {
            // title: 'Ecologic Software',
            description: 'El Dr. Sette es un participante activo en congresos y eventos de nefrología.',
          },
        ],
      },
      callToAction: {
        title: 'Inscríbete para descubrir las 10 novedades del KDIGO de ERC de 2023 que cambian la práctica médica',
      },
    },
    kdigoIraData: {
      meta: {
        title: 'Novedades del KDIGO para IRA 2023',
      },
      activeCampaign: {
        formValue: 'f7b028354cb3223abc2f3c3bd96d2a0f',
        id: '29',
        buttonText: 'Quiero registrarme',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">Los Cambios Prácticos Más Importantes en el <span class="text-accent highlight">KDIGO para IRA 2023</span></span>`,
          },
          subtitle: {
            html: `<span>Participa en nuestra <span class="font-bold">Clase en Vivo a las 20:00 en YouTube.</span><span class="max-md:hidden md:block">Exploraremos y discutiremos los cambios más importantes que trae el KDIGO 2023. Contenido esencial para todos los médicos nefrólogos.</span></span>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'Actualización sobre el KDIGO para IRA 2023',
            description: 'Recibe información actualizada y relevante sobre el nuevo KDIGO 2023.',
          },
          {
            title: 'Profundización en el Tema',
            description:
              'La clase permitirá una comprensión más profunda de los temas discutidos en el KDIGO, con la oportunidad de aclarar dudas en tiempo real.',
          },
          {
            title: 'Comodidad y Conveniencia',
            description:
              'Mira la clase desde la comodidad de tu hogar o cualquier otro lugar, sin necesidad de desplazarte.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">En esta clase obtendrás:</h3>`,
          },
        },
      },
      steps2: {
        title: `Nuestro orador:`,
        subtitle: `El Dr. Luis Sette es un nefrólogo con muchos años de experiencia en el campo. Su pasión por la nefrología y por transmitir conocimiento es evidente en sus charlas atractivas e informativas. El Dr. Sette participó en el reciente Congreso Europeo de Nefrología, adquiriendo nuevos conocimientos e ideas. Está ansioso por compartir estos conocimientos en la clase en vivo, guiando a los nefrólogos a través de los desarrollos más recientes en el campo.`,
        items: [
          {
            // title: 'Experiencia',
            description: 'El Dr. Sette tiene una amplia experiencia clínica y académica.',
          },
          {
            // title: 'Flexible Team',
            description:
              'Es conocido por su habilidad para explicar conceptos complejos de manera clara, lo que hace que el aprendizaje sea una experiencia gratificante.',
          },
          {
            // title: 'Ecologic Software',
            description: 'El Dr. Sette es un participante activo en congresos y eventos de nefrología.',
          },
        ],
      },
      callToAction: {
        title:
          'Regístrate para descubrir las mayores novedades del KDIGO para IRA de 2023 que cambian la práctica médica',
      },
    },
    obrigadoData: {
      meta: {
        title: 'Gracias',
      },
      content: {
        title: 'Gracias',
        success: 'Tu compra se ha realizado con éxito.',
        emailCheck: 'Revisa tu correo electrónico para obtener información sobre el acceso a los cursos.',
        backButton: 'Volver',
      },
    },
    confirmacaoData: {
      meta: {
        title: 'Confirmación de Inscripción',
        link: 'https://devzapp.com.br/api-engennier/camp/redirect/64e3add179ec940001364141',
        cta: 'Ingresar al Grupo de WhatsApp',
      },
      fragment: {
        html: `
          <div class="w-full pt-10 rounded-full px-10">
            <div class="bg-red-600 text-lg font-medium text-white text-center p-1 leading-none rounded-full" style="width: 80%">
              80% Completado
            </div>
          </div>
        `,
      },
      hero: {
        fragments: {
          title: { html: `ACCIÓN NECESARIA` },
          subtitle: {
            html: `Con estos simples pasos, aseguras que recibirás todos mis mensajes y no te perderás ningún detalle de la clase especial que estoy preparando para ti.`,
          },
          content: { title: 'Para finalizar tu inscripción, sigue estos pasos:' },
        },
      },
      steps2: {
        title: 'IMPORTANTE:',
        items: [
          {
            title: 'ÚNETE AL GRUPO EXCLUSIVO DE WHATSAPP',
            description: 'Toda la información y materiales importantes se enviarán al Grupo Exclusivo.',
          },
          {
            title: 'CONFIRMA TU CORREO ELECTRÓNICO DE REGISTRO',
            description:
              'Para que recibas todas mis comunicaciones por correo electrónico sin problemas, es necesario que confirmes tu correo electrónico registrado. Esto indica a la plataforma que te has inscrito y deseas participar.',
          },
        ],
      },
    },
    aulaoData: {
      meta: {
        title: 'Clase de Revisión para el Examen de Especialista en Nefrología',
        link: 'https://pay.hotmart.com/H85294483V?off=nlwxcem6',
        description:
          'Se discutirán las preguntas y se revisarán los temas más recurrentes de los últimos exámenes de manera objetiva y directa al punto',
        subheadline: '17 de octubre',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">Clase de Revisión para <span class="text-accent highlight">Examen de Especialista en Nefrología</span></span>`,
          },
          subtitle: {
            html: `<span class="">Únete a nuestra Clase de Revisión en la <span class="font-bold">fecha 17 de octubre</span>.<span class="max-md:hidden md:block">Se discutirán las preguntas y se revisarán los temas más recurrentes de los últimos exámenes de manera objetiva y directa al punto</span></span>`,
          },
        },
      },
      content: {
        items: [
          {
            title: 'Preparación Específica',
            description:
              'Una clase especial en la víspera para nefrólogos puede enfocar tus estudios en los temas más relevantes y complejos del examen.',
          },
          {
            title: 'Estrategias',
            description:
              'La clase puede proporcionar estrategias efectivas, como la gestión del tiempo, consejos para abordar preguntas de opción múltiple y enfoques para responder a casos clínicos.',
          },
          {
            title: 'Revisión',
            description:
              'En esta clase, tendrás la oportunidad de repasar los contenidos más recurrentes del examen de especialista y aumentar tus posibilidades de aprobación.',
          },
          {
            title: 'Apoyo',
            description:
              'La clase especial puede proporcionar un sentido de comunidad y apoyo emocional antes del examen. Esto puede ser crucial para manejar el estrés y la ansiedad relacionados con el examen.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">¿Cómo Será?</h3>`,
          },
        },
      },
      steps2: {
        title: 'Nuestro Ponente:',
        subtitle:
          'El Dr. Luis Sette es un nefrólogo con muchos años de experiencia en el campo. Su pasión por la nefrología y por transmitir conocimiento es evidente en sus charlas cautivadoras e informativas. El Dr. Sette participó recientemente en el Congreso Europeo de Nefrología, absorbiendo nuevos conocimientos e investigaciones. Está ansioso por compartir este conocimiento en la clase en vivo, guiando a los nefrólogos a través de los últimos avances en el campo.',
        items: [
          {
            description: 'El Dr. Sette tiene una amplia experiencia clínica y académica.',
          },
          {
            description:
              'Es conocido por su habilidad para explicar conceptos complejos de manera clara, lo que hace que el aprendizaje sea una experiencia gratificante.',
          },
          {
            description: 'El Dr. Sette es un participante activo en congresos y eventos de nefrología.',
          },
        ],
      },
      callToAction: {
        text: 'Quiero Inscribirme',
        price: 'R$ 597,00',
        vagas: 'Hasta agotar las plazas (las plazas son limitadas debido al espacio físico)',
        paymentGatewayText: 'Compra de forma segura a través de Hotmart',
      },
    },
    congressoAmericanoData: {
      meta: {
        title: 'Novedades del Congreso Americano de Nefrología',
        description: 'Novedades del Congreso Americano de Nefrología 2023',
      },
      activeCampaign: {
        inputHiddenValue: '9bd5342f53a36892dc30f38a731f2392',
        id: '33',
        buttonText: 'INSCRÍBETE PARA PARTICIPAR',
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl md:text-5xl text-black">DESTACADOS DEL CONGRESO <span class="text-accent highlight">AMERICANO DE NEFROLOGÍA</span></span>`,
          },
          subtitle: {
            html: `
            <span class="font-bold">ACTUALIZACIONES, REVISIONES Y NUEVAS CONDUCTAS</span>
            <br /><br />
            Esta clase exclusiva te ofrecerá la oportunidad de revisar y discutir los puntos más importantes y relevantes presentados en el Congreso Americano de Nefrología 2023 (kidney week)
            <br /><br />
            <span class="font-bold"></span>13 de septiembre a las 20:00h en YouTube.<span class="max-md:hidden md:block"></span>
          `,
          },
        },
      },
      content: {
        items: [
          {
            title:
              '¿Alguna vez te has preguntado cuáles son las ideas más importantes e innovadoras discutidas en el último Congreso Americano de Nefrología?  ',
          },
          {
            title:
              'Esta clase exclusiva te ofrecerá la oportunidad de revisar y discutir los puntos más importantes y relevantes presentados en el evento.',
          },
          {
            title:
              'El Dr. Luis Sette proporciona información actual y de primera mano sobre los hallazgos más significativos en Nefrología.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Sobre la Clase de Revisión</h3>`,
          },
        },
      },
      content2: {
        items: [
          {
            title:
              'Mucho gusto, mi nombre es Luís Sette y soy médico nefrólogo graduado en la USP hace 13 años, con maestría y doctorado en el área y soy profesor adjunto de la disciplina de Nefrología de la Universidad Federal de Pernambuco desde 2014.',
          },
          {
            title:
              'Actualmente, mi práctica médica se lleva a cabo en mi consultorio privado y enseñando en la UFPE a estudiantes de medicina, internos, residentes de clínica y nefrología. ',
          },
          {
            title:
              'En 2020 comenzamos el proyecto NEFROATUAL para democratizar y difundir la enseñanza de Nefrología para todos y contamos con más de 1200 estudiantes.',
          },
        ],
        fragments: {
          content: {
            html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Nuestro Orador</h3>`,
          },
        },
      },
      steps2: {
        title: `¿Por qué deberías asistir?`,
        subtitle: ``,
        items: [
          {
            title: 'Mantente Actualizado:',
            description:
              'Esta clase cubrirá una amplia gama de temas que te permitirán ponerte al día con las últimas investigaciones en Nefrología.',
          },
          {
            title: 'Oportunidad Única:',
            description: 'Tendrás acceso a contenido exclusivo y restringido a pocos profesionales.',
          },
          {
            title: 'Materiales de Apoyo y Recursos Adicionales:',
            description:
              'Además de la clase, los inscritos recibirán un resumen de todo lo que se discutirá en el evento.',
          },
        ],
      },
      callToAction: {
        title: 'Inscríbete para descubrir los mayores DESTACADOS DEL CONGRESO AMERICANO DE NEFROLOGÍA',
      },
    },
    nefroupdates: {
      ofertaData: {
        meta: {
          title: 'Suscripción Anual a NefroUpdates',
          subheadline: '¡Tu fuente confiable de actualizaciones en Nefrología!',
          cta: '',
          link: '',
        },
        hero: {
          fragments: {
            title: {
              html: `Tu actualización semanal de los <span class="text-accent highlight">artículos más importantes de Nefrología</span>`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Ofrecemos resúmenes de revisiones sobre temas clave para la práctica de nefrología, ayudándote a mejorar continuamente tu desempeño</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: 'Actualización Semanal Imprescindible',
              description:
                'Proporcionamos resúmenes semanales de artículos prácticos recién publicados en revistas de renombre como NEJM, Kidney International, JASN y Guidelines KDIGO.',
            },
            {
              title: 'Comprensión Profunda de Temas Cruciales',
              description:
                'Ofrecemos resúmenes de revisiones sobre temas significativos para la práctica del nefrólogo, ayudándote en tu mejora continua.',
            },
            {
              title: 'Tu Guía Práctica',
              description:
                'Presentamos videos cortos con consejos prácticos sobre temas que, aunque no estén en las pautas principales, pueden cambiar tus decisiones.',
            },
            {
              title: 'Club de Revisión - Discusión y Aprendizaje',
              description:
                'Te invitamos a participar en discusiones enriquecedoras y aprender de los artículos más importantes de la Nefrología en nuestro Club de Revisión.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descubre qué hace que NefroUpdates sea especial.</h3>Descubre una experiencia de aprendizaje innovadora impulsada por las últimas investigaciones en Nefrología.`,
            },
          },
        },
        steps2: {
          title: '¿Para quién es NefroUpdates?',
          subtitle:
            'Para médicos interesados en las últimas novedades sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina Interna',
              description: '',
            },
          ],
        },
        content2: {
          image: {
            src: import('~/assets/images/val.webp'),
            alt: 'Valkercyo Feitosa',
          },
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">
                Dr. Valkercyo Feitosa
              </h3>
              Médico nefrólogo graduado en la USP en 2019, doctorando en el área de nefropatías hereditarias y profesor de la Facultad
              de Medicina de Olinda desde 2022. Actualmente, mi práctica médica es el día a día del nefrólogo en la consulta, clínicas
              de hemodiálisis y hospitales universitarios. Desde 2022, formo parte del proyecto NEFROATUAL para simplificar y hacer que la
              Nefrología de alto nivel sea más accesible.
            `,
            },
          },
        },
        faqs: {
          title: 'Preguntas Frecuentes',
          subtitle: 'Preguntas Frecuentes',
          highlight: 'Obtén más información',
          items: [
            [
              {
                question: '¿NefroUpdates tiene garantía? ¿Y si no me gusta?',
                answer:
                  'Sí, ofrecemos una garantía incondicional de 30 días. Si por cualquier motivo decides que el curso no es adecuado para ti dentro de ese período, puedes solicitar un reembolso completo.',
              },
              {
                question: '¿Quiénes son los autores del material?',
                answer:
                  'Todos nuestros artículos y videos son creados por médicos especialistas en nefrología con una amplia experiencia clínica y académica. El Dr. Luís Sette, como editor jefe, se dedica a hacer que la nefrología sea accesible y comprensible para todos.',
              },
            ],
            [
              {
                question: '¿Cómo puedo suscribirme?',
                answer:
                  'La suscripción se puede realizar directamente en nuestra plataforma a través de nuestra asociación con Hotmart. Después de elegir el curso que mejor se adapte a tus necesidades, sigue las instrucciones en la página del curso para completar tu compra.',
              },
              {
                question: '¿Y si tengo más preguntas o necesito ayuda?',
                answer:
                  '¡Estamos aquí para ayudarte! Si tienes más preguntas o necesitas asistencia, no dudes en ponerte en contacto con nosotros a través de Instagram Direct, la plataforma de Hotmart o también a través de nuestro WhatsApp. Nuestro objetivo es garantizar que tengas una experiencia de aprendizaje fluida y enriquecedora.',
              },
            ],
          ],
        },
        steps: {
          title: 'Mantente Actualizado en Cualquier Lugar con Nuestra Aplicación',
          items: [
            {
              title: 'Recibe contenido exclusivo en tu teléfono móvil',
              description:
                'Nunca te pierdas una actualización importante en nefrología. Recibe notificaciones en tiempo real sobre los últimos avances, estudios y tendencias en el campo de la nefrología.',
              icon: 'tabler:device-mobile',
            },
            {
              title: 'Cobertura en Tiempo Real de los Principales Congresos',
              description:
                'Mantente al día en tiempo real con la cobertura de los principales congresos nacionales e internacionales, como si estuvieras presente físicamente.',
              icon: 'tabler:presentation',
            },
          ],
          image: {
            alt: 'Bonificación',
          },
        },
      },
      assinaturaData: {
        meta: {
          title: 'Suscripción Anual a NefroUpdates',
          link: 'https://pay.hotmart.com/G78906779P?off=fo3g4yii&checkoutMode=10',
          description: '',
          subheadline: 'Tu fuente confiable de actualización en Nefrología',
          cta: 'Quiero probar gratis por 30 días',
        },
        hero: {
          fragments: {
            title: {
              html: `Tu actualización semanal de los <span class="text-accent highlight">Artículos más importantes de Nefrología</span>`,
            },
            subtitle: {
              html: `<span class="hidden sm:inline">Ofrecemos resúmenes de revisiones sobre los principales temas para la práctica del nefrólogo, ayudando en tu mejora continua.</span>`,
            },
          },
        },
        content: {
          items: [
            {
              title: 'Actualización Semanal Imprescindible',
              description:
                'Proporcionamos resúmenes semanales de artículos prácticos recién publicados en revistas de renombre como NEJM, Kidney International, JASN y Guidelines KDIGO.',
            },
            {
              title: 'Comprensión Profunda de Temas Cruciales',
              description:
                'Ofrecemos resúmenes de revisiones sobre temas significativos para la práctica del nefrólogo, ayudando en la mejora continua de tu desempeño.',
            },
            {
              title: 'Tu Guía Práctica',
              description:
                'Presentamos videos cortos con consejos prácticos sobre temas que, aunque no estén en las pautas principales, son capaces de transformar tus decisiones.',
            },
            {
              title: 'Club de Revisión - Discusión y Aprendizaje',
              description:
                'Invítate a participar en discusiones enriquecedoras y aprende de los artículos más importantes de la Nefrología en nuestro Club de Revisión.',
            },
          ],
          fragments: {
            content: {
              html: `<h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">Descubre lo que hace que NefroUpdates sea especial.</h3>Descubre una experiencia de aprendizaje innovadora impulsada por las últimas investigaciones en Nefrología.`,
            },
          },
        },
        steps2: {
          title: '¿Para quién es NefroUpdates?',
          subtitle:
            'Para médicos interesados en las últimas novedades sobre Nefrología y enfermedades renales. <br> <br>',
          items: [
            {
              title: 'Nefrólogos',
              description: '',
            },
            {
              title: 'Residentes en Nefrología',
              description: '',
            },
            {
              title: 'Médicos Generalistas',
              description: '',
            },
            {
              title: 'Clínicos y Residentes de Medicina Interna',
              description: '',
            },
          ],
        },
        content2: {
          fragments: {
            content: {
              html: `
              <h3 class="text-2xl font-bold tracking-tight dark:text-white sm:text-3xl mb-2">
                Dr. Valkercyo Feitosa
              </h3>
              Médico nefrólogo graduado en la USP en 2019, doctorando en el área de nefropatías hereditarias y profesor de la Facultad de Medicina de Olinda desde 2022. Actualmente, mi práctica médica es el día a día del nefrólogo en la consulta, clínicas de hemodiálisis y hospitales universitarios. Desde 2022, formo parte del proyecto NEFROATUAL para simplificar y hacer que la Nefrología de alto nivel sea más accesible.
            `,
            },
          },
        },
        faqs: {
          title: 'Preguntas Frecuentes',
          subtitle: 'Todo lo que necesitas saber sobre NefroUpdates',
          highlight: 'Obtén más información',
          items: [
            [
              {
                question: '¿NefroUpdates tiene garantía? ¿Y si no me gusta?',
                answer:
                  'Sí, ofrecemos una garantía incondicional de 30 días. Si por cualquier motivo decides que el curso no es adecuado para ti dentro de ese período, puedes solicitar un reembolso completo.',
              },
              {
                question: '¿Quiénes son los autores del material?',
                answer:
                  'Todos nuestros artículos y videos son creados por médicos especialistas en nefrología con una amplia experiencia clínica y académica. El Dr. Luís Sette, como editor jefe, se dedica a hacer que la nefrología sea accesible y comprensible para todos.',
              },
            ],
            [
              {
                question: '¿Cómo puedo suscribirme?',
                answer:
                  'La suscripción se puede realizar directamente en nuestra plataforma a través de nuestra asociación con Hotmart. Después de elegir el curso que mejor se adapte a tus necesidades, sigue las instrucciones en la página del curso para completar tu compra.',
              },
              {
                question: '¿Y si tengo más preguntas o necesito ayuda?',
                answer:
                  '¡Estamos aquí para ayudarte! Si tienes más preguntas o necesitas asistencia, no dudes en ponerte en contacto con nosotros a través de Instagram Direct, la plataforma de Hotmart o también a través de nuestro WhatsApp. Nuestro objetivo es garantizar que tengas una experiencia de aprendizaje fluida y enriquecedora.',
              },
            ],
          ],
        },
        steps: {
          title: 'Mantente Actualizado en Cualquier Lugar con Nuestra Aplicación',
          items: [
            {
              title: 'Recibe contenido exclusivo en tu teléfono móvil',
              description:
                'Nunca te pierdas una actualización importante en nefrología. Recibe notificaciones en tiempo real sobre los últimos avances, estudios y tendencias en el campo de la nefrología.',
              icon: 'tabler:device-mobile',
            },
            {
              title: 'Cobertura en Tiempo Real de los Principales Congresos',
              description:
                'Mantente al día en tiempo real con la cobertura de los principales congresos nacionales e internacionales, como si estuvieras presente físicamente.',
              icon: 'tabler:presentation',
            },
          ],
          image: {
            alt: 'Bono',
          },
        },
        price: {
          price: 'R$ 997,00',
          price12x: 'o en 12 cuotas de R$ 99,50',
        },
      },
      postData: {
        dialog: {
          title: 'Contenido exclusivo para suscriptores',
          description: 'Prueba NefroUpdates gratis durante 30 días.',
          buttons: {
            assinatura: 'Quiero saber más',
            signin: 'Ya soy suscriptor',
          },
        },
      },
    },
    mapaData: {
      meta: {
        title: 'Mapa de las Glomerulopatías',
      },
      hero: {
        fragments: {
          title: { html: `El Mapa de las <span class="text-accent highlight">Glomerulopatías</span>` },
          subtitle: {
            html: `<span class="max-h-90">El Dr. Luís Sette enseñará de manera didáctica y sencilla un camino para diagnosticar las glomerulopatías más comunes y adaptar las mejores conductas terapéuticas.</span>`,
          },
        },
      },
      hero2: {
        fragments: {
          title: {
            html: `<span class="text-4xl text-center justifycenter">Del 26 de septiembre al 1 de octubre - Siempre a las 20:00</span>`,
          },
          subtitle: {
            html: `
            <div class="flex justify-center space-x-3">
              <a href="#aula1">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Clase 1 <br />Martes 26/09</button>
              </a>
              <a href="#aula2">
                <button type of "button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Clase 2 <br />Miércoles 27/09</button>
              </a>
              <a href="#aula3">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Clase 3 <br /> Jueves 28/09</button>
              </a>
              <a href="#aula4">
                <button type="button" class="px-3 py-1 text-white bg-blue-500 rounded focus:outline-none">Clase 4 <br /> Domingo 01/09</button>
              </a>
            </div>
          `,
          },
          aula1: {
            html: `
            <h2 class="text-lg p-3">
              <strong>CLASE 1: PUNTO DE PARTIDA</strong>
              <br />
              En la clase de hoy, presenté 3 casos clínicos tratados por mí y presenté el Punto de Partida de cada paciente. Cómo identificar las Glomerulopatías y dar los primeros pasos.
            </h2>
            <span class="p-50">
              <a href="https://drive.google.com/file/d/1fYoljuwMfE70_pYc81gAnWbUY-SNUQqA/view?usp=sharing" target="_blank">
                <button class="bg-blue-500 hover-bg-blue-700 text-white font-bold py-3 px-4 rounded">Descargar Resumen de la Clase</button>
              </a>
              <a href="https://devzapp.com.br/api-engennier/camp/redirect/64e3add179ec940001364141" target="_blank">
                <button class="bg-green-500 hover-bg-green-700 text-white font-bold py-3 px-4 rounded">Unirse al Grupo de Whatsapp</button>
              </a>
            </span><br /><br /><hr /><br />
          `,
          },
          aula2: {
            html: `
            <h2 class="text-lg p-5">
              <strong>CLASE 2: PUNTO DE PARADA</strong>
              <br />
              En el segundo encuentro del Mapa de las Glomerulopatías mostraré cómo interpretar los exámenes y la biopsia renal.
            </h2>
            <a href="https://drive.google.com/file/d/1XDQhQU-S-LM4AWrgizVgGAG7svWuXgI6/view?usp=sharing" target="_blank">
              <button class="bg-blue-500 hover-bg-blue-700 text-white font-bold py-3 px-4 rounded">Descargar Resumen de la Clase</button>
            </a><br /><br /><hr /><br />
          `,
          },
          aula3: {
            html: `
            <h2 class="text-lg p-5">
              <strong>CLASE 3: PUNTO DE LLEGADA</strong>
              <br />
              Hay varios tratamientos para las Glomerulopatías y en este tercer encuentro mostraré cuáles son los tratamientos generales y específicos para cada patología.
            </h2>
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfcV-yE7-qDLFKTsQSoka8K5c8Ilk9ypKiPUEwXids7t1-4FQ/viewform" target="_blank">
              <button type="button" class="bg-yellow-400 hover-bg-orange-400 text-white font-bold py-3 px-4 rounded">Responder la Encuesta</button>
            </a>
            <a href="https://drive.google.com/file/d/1C6fmY0QtmmyRgUzv_k9ucro-MMww93kO/view?usp=sharing" target="_blank">
              <button type="button" class="bg-blue-500 hover-bg-blue-700 text-white font-bold py-3 px-4 rounded">Descargar Resumen de la Clase</button>
            </a><br /><br /><hr /><br />
          `,
          },
          aula4: {
            html: `
            <h2 class="text-lg p-5">
              <strong>CLASE 4: ENCONTRANDO EL TESORO</strong>
              <br />
              Siguiendo nuestro Mapa, en el tercer y último encuentro mostraré cómo puedes mantenerte actualizado y ofrecer lo más moderno y eficiente a tus pacientes. También tendremos nuestro Gran Sorteo para quienes participaron en la ENCUESTA.
            </h2>
            <button type="button" disabled class="bg-blue-500 hover-bg-blue-700 text-white font-bold py-3 px-4 rounded">Descargar Resumen de la Clase</button>
          `,
          },
        },
      },
    },
  },
} as const;
